export const messages = {
  "settings.title": "Profildata",
  "settings.name": "Navn",
  "settings.password": "Adgangskode",
  "settings.mail": "E-mail",
  "settings.phone": "Telefon",
  "settings.address": "Adresse",
  "settings.button.close": "Luk",
  "settings.button.save": "Gem",
  "settings.edit": "Rediger profil",
  "settings.logout": "Log ud",
  "settings.nodata": "ikke angivet",
  "settings.tradingName": "Firmanavn",
  "settings.language": "Sprog",
  "settings.areaUnit": "Arealenhed",
  "settings.areaUnit.hectares": "Hektar (ha)",
  "settings.areaUnit.acres": "Acres (ac)",
  "settings.button.edit": "Rediger",
  "settings.button.cancel": "Annuller",
  "settings.changePassword": "Skift adgangskode",
  "settings.newPassword": "Ny adgangskode",
  "settings.confirmPassword": "Bekræft ny adgangskode",
  "settings.password.hint":
    "Lad feltet stå tomt for at beholde din nuværende adgangskode",
  "settings.password.mismatch": "Adgangskoderne stemmer ikke overens",
  "settings.name.required": "Navn er påkrævet",
  "settings.mail.invalid": "Indtast venligst en gyldig e-mailadresse",
  "settings.update.success": "Profil opdateret",
  "settings.update.error": "Profilen kunne ikke opdateres. Prøv igen.",
  "passwordChange.success": "Adgangskode ændret",
  "login.heading": "Afgræsningsapp",
  "login.dialog.title": "Log ind",
  "login.dialog.reset": "Glemt adgangskode",
  "login.reset.popover": "Skriv en e-mail til hello@ruumi.io",
  "login.dialog.signup": "Opret konto",
  "login.mail.label": "E-mail",
  "login.password.label": "Adgangskode",
  "login.button.label": "Log ind",
  "signup.heading": "Afgræsningsapp",
  "signup.dialogTitle.userDetails": "Indtast dine oplysninger",
  "signup.dialogTitle.farmDetails": "Fortæl os om din bedrift",
  "signup.button.signup": "Opret konto",
  "signup.button.next": "Næste",
  "signup.button.back": "Tilbage",
  "signup.button.getStarted": "Kom i gang",
  "signup.mail.label": "E-mail",
  "signup.name.label": "Navn",
  "signup.tradingName.label": "Firmanavn (valgfrit)",
  "signup.phone.label": "Tlf.",
  "signup.password.label": "Adgangskode",
  "signup.size.label": "Størrelse i ha",
  "signup.farmType.label": "Bedriftstype",
  "signup.TandC":
    "Ved at oprette en konto accepterer du vores <a>privatlivspolitik</a>.",
  "signup.farmType.beef": "Kvæg",
  "signup.farmType.beef_sheep": "Kvæg & får",
  "signup.farmType.sheep": "Får",
  "signup.farmType.dairy": "Malkekøer",
  "signup.farmType.other": "Andet",
  "signup.cbInterest.label": "Interesse i Carbon Farming",
  "signup.cbInterest.yes": "Ja",
  "signup.cbInterest.no": "Nej",
  "signup.welcome.enterFields.title": "Indtast marker",
  "signup.welcome.title": "Velkommen",
  "signup.welcome.text":
    "Her er nogle tips til at komme i gang. Hvis du har spørgsmål, er du altid velkommen til at kontakte os",
  "signup.welcome.link": "Kontakt support",
  "signup.welcome.enterFields.text":
    "Med få klik kan du tegne marker direkte på kortet. Vi beregner græsdækket på få sekunder, så du kan se det. Hvis du har en stor bedrift, kan du sende os en fil med dine markgrænser, så uploader vi dem for dig.",
  "signup.welcome.enterAnimalGroups.title": "Indtast dyregrupper",
  "signup.welcome.enterAnimalGroups.text":
    "Vi registrerer græsudbuddet fra rummet, men vi har brug for din hjælp til den anden del af ligningen: dyrenes behov. Opret dyregrupper med så mange dyrekategorier, som du ønsker. Hvis du vil have råd om, hvordan du beregner det præcise behov pr. dyr, så kontakt os endelig.",
  "signup.welcome.planRotations.title": "Planlæg dine rotationer",
  "signup.welcome.planRotations.text":
    "Når du har oprettet markerne og dyregrupperne, kan du flytte dine dyr og planlægge dine rotationer ved hjælp af Grass Wedge. Tilknyt marker eller ej, juster rotationslængden og afgræsningsmålet. Den blå behovslinje viser dig, hvor du har overskud eller underskud.",
  "edit.editingField": "Rediger mark",
  "edit.addingField": "Tilføj ny mark",
  "edit.editingAnimalGroup": "Rediger dyregruppe",
  "edit.addingAnimalGroup": "Tilføj ny dyregruppe",
  "edit.fieldname.label": "Marknavn",
  "edit.animalGroupName.label": "Navn på dyregruppe",
  "edit.stockClassName.label": "Dyretype (tilføj ny eller brug skabelon)",
  "edit.stockClassName.feedBudgetPlanner.label": "Dyrenavn",
  "edit.stockClassNrOfAnimals.label": "Antal dyr",
  "edit.stockClassAvgWeight.label": "Gennemsnitsvægt",
  "edit.minNumber.error": "Skal mindst være {min}",
  "edit.maxNumber.error": "Skal være mindre end eller lig med {max}",
  "edit.required.error": "Dette felt er påkrævet",
  "edit.number.error": "Dette felt skal være et tal",
  "edit.stockClassFeedType.label": "Fodring (f.eks. 'Tør - vedligehold')",
  "edit.stockClassDemand.label": "Dagligt foderbehov",
  "edit.stockClassDefaultStockClass.label": "Dyrekategori",
  "edit.weight.label": "Gruppevægt",
  "edit.demand.label": "Foderbehov",
  "edit.button.cancel": "Annuller",
  "edit.button.save": "Gem",
  "edit.button.edit": "Rediger",
  "edit.button.back": "Tilbage",
  "edit.button.next": "Næste",
  "edit.button.confirm": "Bekræft",
  "map.drawfield.drawTools.aria": "Tegneværktøjer",
  "map.drawfield.tooltip": "Tegn eller rediger ydre hegn",
  "map.drawfield.help.tooltip": "Hjælp til tegning",

  "map.drawfield.help.modal.title": "Hjælp til markeditor",
  "map.drawfield.help.modal.welcome":
    "Velkommen til ruumi-markeditoren! Her er nogle tips til at komme i gang med at tegne marker. Hvis du har spørgsmål, er du altid velkommen til at kontakte os",
  "map.drawfield.help.modal.link": "Kontakt support",
  "map.drawfield.help.modal.createMode.title": "Opret en ny markgrænse",
  "map.drawfield.help.modal.createMode.description":
    'Hvis der ikke er nogen markgrænse endnu (eller efter den er slettet), tryk på knappen <pencilButton></pencilButton> for at skifte til "Opret"-tilstand. Tegn derefter den nye markgrænse ved at klikke på markens kanter på kortet. Markgrænsen tegnes efter dine klik.',
  "map.drawfield.help.modal.createMode.zoomControls.description":
    "Brug <navIcon></navIcon>-knapperne til at zoome ind og ud for mere præcision.",
  "map.drawfield.help.modal.createMode.undo.description":
    'Hvis du har klikket forkert, kan du fortryde med <undoButton></undoButton>-knappen. Det er ikke muligt at ændre markgrænsen i "Opret"-tilstand, kun at fortryde trin for trin.',
  "map.drawfield.help.modal.createMode.boundaryCorrectness.description":
    'Bemærk, at markgrænsen skal være en konveks form med mindst 3 punkter for at kunne gemmes. Når grænsen er korrekt, bliver areal og grænse synlige, og knappen "GEM" bliver aktiv.',
  "map.drawfield.help.modal.createMode.finish.description":
    'Når du er færdig med at tegne, klik enten på <pencilButton></pencilButton> eller tryk "Enter" for at forlade "Opret"-tilstand. Så kan du gemme marken.',
  "map.drawfield.help.modal.editMode.title": "Rediger eksisterende markgrænse",
  "map.drawfield.help.modal.editMode.description":
    'Hvis markgrænsen allerede findes, skift til "Rediger"-tilstand ved at trykke på <pencilButton></pencilButton>-knappen.',
  "map.drawfield.help.modal.editMode.move.description":
    "Flyt eksisterende punkter ved at klikke og trække: <movePointImg></movePointImg>. Tilføj nye punkter ved at klikke på markgrænsen (røde linjer).",
  "map.drawfield.help.modal.editMode.select.description":
    'Dobbeltklik på punkter for at vælge dem. De valgte punkter bliver røde: <selectPointImg></selectPointImg>. Slet valgte punkter med knappen <deleteButton></deleteButton> eller tryk på "Delete"-tasten. Flere punkter kan vælges og slettes på én gang. Dobbeltklik igen på det valgte punkt for at fravælge det.',
  "map.drawfield.help.modal.editMode.finish.description":
    'Når du er færdig med at redigere, klik enten på <pencilButton></pencilButton> eller tryk "Enter" for at forlade "Rediger"-tilstand. Så kan du gemme marken.',
  "map.drawfield.help.modal.deleteBoundary.title": "Slet hele markgrænsen",
  "map.drawfield.help.modal.deleteBoundary.description":
    'Nogle gange kan det være nødvendigt at tegne markgrænsen forfra. Hvis du ikke er i "Opret"- eller "Rediger"-tilstand, brug <deleteButton></deleteButton> til at slette hele markgrænsen. Skift derefter til "Opret"-tilstand og tegn den nye grænse.',
  "map.drawfield.help.modal.close": "Luk",
  "map.deletefeature.tooltip": "Slet valgt feature (også med Delete-tasten)",
  "map.deleteTentativePosition.tooltip":
    "Slet forrige punkt (også med Delete-tasten)",
  "map.deleteSelectedHandles.tooltip": "Slet de valgte punkter",
  "map.clickOnPencilButton.hint":
    "Tryk på ✏️-knappen og klik derefter på kortet for at tegne marken.",
  "map.clickOnPencilButtonToEdit.hint":
    "Tryk på ✏️-knappen for at redigere eller slette marken.",
  "map.provideThreePoints.hint":
    "Tilføj mindst 3 punkter for at oprette en konveks markgrænse.",
  "map.provideValidGeometry.hint":
    "Markgeometrien er ugyldig, opret venligst en konveks markgrænse med mindst 3 punkter.",
  "map.doubleClickToFinish.hint":
    "Klik på det sidste punkt eller på ✏️-knappen for at afslutte tegningen.",
  "map.editingField.hint":
    "Flyt punkterne eller klik på grænsen for at tilføje et nyt, klik på punkter for at vælge dem. Tryk på ✏️-knappen igen for at afslutte.",
  "map.deleteHandles.hint":
    "Klik på de valgte punkter igen for at fravælge dem.",
  "map.unableDeleteHandles.hint":
    "Det er ikke muligt at fjerne valgte punkter, da markgrænsen skal have mindst 3 punkter efter fjernelse, fravælg venligst nogle",
  "map.deletefeature.confirmation.title": "Slet mark",
  "map.deletefeature.confirmation.description":
    "Hele markgrænsen vil blive fjernet, vil du fortsætte?",
  "map.deletefeature.confirmation.confirm.label": "Slet",
  "map.deletefeature.confirmation.cancel.label": "Fortsæt redigering",
  "menu.paddocks.label": "Folde (preview)",
  "menu.herds.label": "Besætninger (preview)",
  "menu.history.label": "Logger (preview)",
  "warning.tooltip.title": "Overgræsset!",
  "fieldinput.area.text": "Størrelse",
  "fieldinput.area.unit": "ha",
  "fieldinput.na": "N/A",
  "fieldinput.boundary.error": "Ugyldig markgrænse",
  "fieldinput.save.error": "Kunne ikke gemme",
  "fieldinput.assignedTo.silage": "Ensilage",
  "fieldinput.assignedTo.text": "Tilknyttet til",
  "fieldinput.grassType.notsetyet": "N/A",
  "fieldinput.grassType.text": "Græssammensætning",
  "fieldinput.grassType.option.PERMANENT_PASTURE": "Permanent græs",
  "fieldinput.grassType.option.HERBAL_LEY": "Urteblanding",
  "fieldinput.grassType.option.RYE_GRASS": "Rajgræs",
  "fieldinput.grassType.option.RYE_GRASS_AND_CLOVER": "Rajgræs med kløver",
  "fieldinput.grassType.option.WILDFLOWER_MEADOW": "Vilde blomster",
  "fieldinput.grassType.option.LUCERNE_SAINFOIN": "Lucerne og esparsette",
  "fieldinput.grassType.option.BRASSICAS": "Kål",
  "fieldinput.grassType.option.OTHER": "Andre",
  "fieldinput.arableType.option.WHEAT": "Hvede",
  "fieldinput.arableType.option.BARLEY": "Byg",
  "fieldinput.arableType.option.OILSEED_RAPE": "Raps",
  "fieldinput.arableType.option.POTATO": "Kartofler",
  "fieldinput.arableType.option.MAIZ": "Majs",
  "fieldinput.arableType.option.CEREALS": "Korn",
  "fieldinput.arableType.option.VEGETABLES_SALAD": "Grøntsager og salat",
  "fieldinput.arableType.option.OTHERS": "Andre",
  "fieldinput.fieldType.option.ARABLE": "Ager",
  "fieldinput.fieldType.option.GRASS": "Græs",
  "fieldinput.fieldType.text": "Markens type",
  "fieldinput.arableType.text": "Agertype",
  "fieldList.arable.fields": "Agermarker",
  "fieldlist.emptyArable": "Ingen agermarker",
  " fieldinput.arableType.notsetyet": "Vælg venligst",
  "fieldinput.title.mobile": "Indtast detaljer",
  "fieldinput.addField.instructions":
    "Klik på ✏️ ovenfor, klik derefter på kortet for at tegne markgrænsen. Dobbeltklik på markgrænsen for at afslutte tegningen.",
  "fieldview.area.text": "Størrelse",
  "fieldview.area.unit": "ha",
  "fieldview.perimeter.text": "Omkreds",
  "fieldview.perimeter.unit": "m",
  "fieldview.availableDryMatter.text": "Tilgængeligt tørstof",
  "fieldview.availableDryMatter.unit": "kgTS",
  "fieldview.grazingDaysAhead.text": "Tilbageværende græsningsdage",
  "fieldview.grazingDaysAhead.unit": "{days}d {hours}t",
  "fieldview.growth.text": "Vækstrate",
  "fieldview.growth.unit": "kgTS/ha/dag",
  "fieldview.totalCover.text": "TS-tæthed",
  "fieldview.totalCover.unit": "kgTS/ha",
  "fieldview.notfound": "404 - Ikke fundet!",
  "fieldview.overgrazed": "overgræsset",
  "fieldview.noDryMatterNow.text": "(beregner)",
  "fieldview.fieldUpdate.success": "Mark gemt",
  "fieldview.fieldUpdate.error": "Marken kunne ikke gemmes",
  "fieldview.lastUpdated": "Opdateret",
  "fieldview.assignedto.text": "Tilknyttet til",
  "fieldview.moveAnimals.text": "Flyt dyr",
  "fieldview.animalsOnThisField.text": "Dyr er på denne mark",
  "popover.availableDM.unit": "kgTS",
  "popover.availableDM.short": "tilg.",
  "popover.noDryMatterNow.text": "(beregner)",
  "fieldlist.dryMatterNow.unit": "kgTS/ha",
  "fieldlist.noDryMatterNow.text": "(beregner)",
  "fieldlist.empty": "Ingen marker tilknyttet",
  "fieldlist.emptySilage": "Ingen marker i ensilage",
  "fieldevents.silage.title": "Slået til ensilage",
  "fieldevents.silage.dates": "Slåningsdato: {dateCut}",
  "fieldevents.grazed.title": "Afgræsset",
  "fieldevents.moveIn.title": "Lukket ind",
  "fieldevents.moveOut.title": "Lukket ud",
  "fieldevents.grazed.dateIn": "Start: {dateIn}",
  "fieldevents.grazed.dateOut": "Slut: {dateOut}",
  "fieldevents.event.preCover": "Dække før: {preCover} kgTS/ha",
  "fieldevents.event.postCover": "Dække efter: {postCover} kgTS/ha",
  "fieldevents.reading.title": "Dække opdateret",
  "fieldevents.reading.value": "Nyt dække: {value} kgTS/ha",
  "fieldevents.reading.date": "Opdateret den: {date}",
  "fieldevents.list.title": "Aktiviteter",
  "fieldevents.menu.edit": "Rediger",
  "fieldevents.menu.accept": "Acceptér",
  "fieldevents.menu.reject": "Afvis",
  "fieldevents.menu.delete": "Slet",
  "fieldevents.notify.deleted": "Hændelse slettet",
  "fieldevents.notify.accepted": "Automatisk registreret hændelse accepteret",
  "fieldevents.notify.rejected": "Automatisk registreret hændelse afvist",
  "fieldevent.autodetected.tooltip": "Automatisk registreret hændelse",
  "fieldevent.manualinput.tooltip": "Hændelse indtastet af dig",
  "farm.growth.label": "Vækstrate",
  "farm.growth.unit": "kgTS/ha/dag",
  "farm.totalDM.label": "Gennemsnitlig TS-tæthed",
  "farm.totalDM.unit": "kgTS/ha",
  "farm.cover.computing": "Beregnes",
  "farm.cover.done": "Færdig",
  "farm.coverData.label": "Dækningsdata",
  "farm.coverData.ready": "{ready}/{total} klar",
  "farm.availableDM.label": "Tilgængeligt foder",
  "farm.availableDM.unit": "t TS",
  "farm.metrics.title": "Bedriftsnøgletal",
  "farm.animals": "Dyr",
  "farm.totalArea": "Samlet areal",
  "farm.fields": "Marker",
  "farm.title": "Bedrift",
  "farm.prefix": "Bedrift",
  "field.prefix": "Mark",
  "animalGroup.prefix": "Gruppe",
  "farm.menu.edit": "Rediger bedrift",
  "farm.menu.delete": "Slet bedrift",
  "farm.edit.title": "Rediger bedrift",
  "farm.edit.nameLabel": "Bedriftsnavn",
  "farm.edit.locationLabel": "Bedriftens placering",
  "farm.edit.locationHint":
    "Flyt og zoom på kortet for at justere bedriftens grænse",
  "farm.edit.success": "Bedrift opdateret",
  "farm.delete.success": "Bedrift slettet",
  "farm.delete.inProgress": "Bedriften slettes...",
  "farm.delete.notOwner": "Kun ejeren kan slette denne bedrift",
  "farm.delete.selectFarm.title": "Vælg bedrift",
  "farm.delete.selectFarm.description":
    'Bedriften "{name}" vil blive slettet. Vælg den bedrift, du vil skifte til:',
  "confirmationdeletedialog.farm.title": "Slet bedrift",
  "confirmationdeletedialog.farm.description":
    'Er du sikker på, at du vil slette "{name}"? Dette sletter permanent alle marker, dyregrupper og data på denne bedrift.',
  "farm.addMenu.field": "Tilføj mark",
  "farm.addMenu.cover": "Tilføj måling",
  "farm.addMenu.addGrassTypes": "Angiv græssorter",
  "farm.addMenu.animalGroup": "Tilføj dyregruppe",
  "farm.add.addName.mobile": "Indtast bedriftsnavn",
  "farm.add.addName.desktop": "Indtast bedriftens navn",
  "farm.add.saveLocation.desktop": "Find placering på kortet ",
  "farm.add.saveFarm.desktop": ", klik derefter på gem.",
  "farm.add.saveLocation.mobile": "Gem placering",
  "farm.add.addName.error": "Indtast et navn",
  "farm.add.locationInstructions":
    "Zoom ind på din bedrifts placering, eller brug postnummersøgning øverst, og klik derefter på gem.",
  "addCovers.next.label": "Næste",
  "addCovers.back.label": "Tilbage",
  "addCovers.cancel.label": "Annuller",
  "addCovers.save.label": "Gem",
  "addCovers.enterTime.heading": "Indtast tid",
  "addCovers.enterTime.subheading": "Hvornår målte du?",
  "addCovers.enterTime.dateLabel": "Dato",
  "addCovers.enterTime.startTimeLabel": "Starttid",
  "addCovers.enterTime.endTimeLabel": "Sluttid",
  "addCovers.enterTime.invalidFinishTime": "Sluttid skal være efter starttid.",
  "addCovers.enterCovers.heading": "Indtast målinger",
  "addCovers.enterCovers.subheading": "Indtast venligst dine målinger.",
  "addCovers.enterCovers.fieldName": "Mark",
  "addCovers.enterCovers.current": "Aktuel",
  "addCovers.enterCovers.new": "Måling",
  "addNewEvent.button": "Registrer hændelse",
  "addNewEvent.type.seeding": "Såning",
  "addNewEvent.type.fertilizer": "Gødskning",
  "addNewEvent.type.harvest": "Høst",
  "addNewEvent.type.measurement": "Måling",
  "addNewEvent.type.feeding": "Fodring",
  "addNewEvent.type.purchase": "Indkøb",
  "addNewEvent.type.other": "Andet",
  "addCovers.singleEvent.title": "Indtast hændelse",
  "addCovers.singleEvent.tooltip": "Indtast hændelse",
  "addCovers.single.unit": "kgTS/ha",
  "addCovers.single.measurementDatetime": "Måletidspunkt",
  "addCovers.single.newCover": "Måling",
  "addCovers.enterReasons.heading": "Hændelse",
  "addCovers.enterReasons.subheading":
    "Vi har vist ikke set alt. Hvad gik vi glip af?",
  "addCovers.enterReasons.fieldName": "Mark",
  "addCovers.enterReasons.difference": "Afvigelse",
  "addCovers.enterReasons.reason": "Årsag",
  "addCovers.enterReasons.menu.grazed": "Afgræsset",
  "addCovers.enterReasons.menu.partGrazed": "Afgræsser",
  "addCovers.enterReasons.menu.silage": "Ensilage",
  "addCovers.enterReasons.menu.noEvent": "Ingen hændelse",
  "addCovers.eventInput.preCover.Label": "TS før",
  "addCovers.eventInput.postCover.Label": "TS efter",
  "addCovers.eventInput.postCover.Error":
    "TS efter hændelse skal være lavere end før.",
  "addCovers.eventInput.dateCut.Label": "Slåningsdato",
  "addCovers.eventInput.dateIn.Label": "Afgræsningsstart",
  "addCovers.eventInput.dateOut.Label": "Afgræsningsslut",
  "addCovers.eventInput.dateOut.Error":
    "Afgræsningsslut skal være efter afgræsningsstart.",
  "addCovers.confirmCovers.heading": "Bekræft og gem",
  "addCovers.confirmCovers.noData":
    "Ingen data indtastet. Gå tilbage for at indtaste data.",
  "addCovers.confirmCovers.accuracy":
    "Vores målinger var inden for {threshold} kg TS/ha fra de målinger, du indtastede.",
  "addCovers.confirmCovers.datetime":
    "Dine målinger fra {readingsDate} kl. {startTime} - {endTime} bliver gemt.",
  "addCovers.confirmCovers.infoMessage":
    "Kortet og Grass Wedge bliver tilpasset.",
  "addCovers.dialog.title": "Måling",
  "addCovers.success": "Målinger gemt.",
  "addCovers.failure": "Det lykkedes ikke at gemme målingerne.",

  "confirmCovers.thumbsUp.tooltip": "Måling ser god ud - klik for at bekræfte",
  "confirmCovers.thumbsUp.alreadyGiven":
    "Du har allerede bekræftet denne måling i dag",
  "confirmCovers.thumbsUp.title": "Måling ser god ud!",
  "confirmCovers.thumbsUp.text":
    "<p>Det betyder, at målingen er nøjagtig nok til at træffe en beslutning om afgræsningsstyring.</p><p>Bekræft venligst målingen, så vi kan lære af den.</p>",
  "confirmCovers.thumbsUp.cancel": "Annuller",
  "confirmCovers.thumbsUp.save": "Bekræft",
  "confirmCovers.thumbsUp.thankYou.title": "Tak for din feedback!",
  "confirmCovers.thumbsUp.thankYou.text":
    "Din tilbagemelding hjælper os med at forbedre målingerne for alle.",
  "confirmCovers.thumbsUp.thankYou.close": "Super!",

  "confirmCovers.thumbsDown.tooltip": "Måling er upræcis - klik for at rette",
  "confirmCovers.thumbsDown.alreadyGiven":
    "Du har allerede opdateret målingen i dag",
  "confirmCovers.thumbsDown.title": "Måling er upræcis!",
  "confirmCovers.thumbsDown.text":
    "<p>Det betyder, at målingen ikke er nøjagtig nok til at træffe en beslutning om afgræsningsstyring.</p><p>Indtast venligst målingen, så vi kan estimere fremtidige målinger bedre.</p>",
  "confirmCovers.thumbsDown.cancel": "Annuller",
  "confirmCovers.thumbsDown.save": "Bekræft",
  "confirmCovers.thumbsDown.thankYou.title": "Tak for din feedback!",
  "confirmCovers.thumbsDown.thankYou.text":
    "Din tilbagemelding hjælper os med at forbedre målingerne for alle.",
  "confirmCovers.thumbsDown.thankYou.close": "Super!",

  "reseedEvent.heading": "Genså",
  "addDate.enterTime.dateLabel": "Dato",
  "reseedEvents.selectFields.text": "Mark(er)",
  "reseedEvent.grassType.text": "Ny græstype",
  "reseedEvent.grassType.placeholder": "Vælg græstype",
  "reseedEvent.seedingMethod.placeholder": "Vælg metode",
  "reseedEvent.notes.label": "Noter",
  "reseedEvents.show.title": "Genså",
  "reseedEvents.show.titleName": "Gensået {name}",
  "reseedEvent.reseedDate": "Dato: {reseedDate}",
  "reseedEvent.newGrassType": "Græstype: {newGrassType}",
  "editReseedEvent.heading": "Rediger gensåning",
  "editReseedEvent.field.heading": "Marknavn",
  "viewReseedEvent.heading": "Vis gensåningshændelse",
  "editReseedEvent.success": "Gensåning redigeret",
  "farm.addMenu.addReseedEvent": "Tilføj gensåning",
  "addGrassType.save.label": "Gem",
  "addGrassType.cancel.label": "Annuller",
  "addGrassType.enterGrassType.heading": "Angiv græssorter",
  "addGrassType.enterGrassType.subheading":
    "Vælg venligst græssorter for marker, hvor det endnu ikke er gjort.",
  "addGrassType.enterGrassType.tableHeading": "Angiv græssorter",
  "addGrassType.enterGrassType.fieldName": "Mark",
  "addGrassType.enterGrassType.selection": "Græssorter",
  "updateGrassTypes.success": "Græssort opdateret",
  "fieldlistmenu.silage.label": "Flyt til ensilage",
  "fieldlistmenu.animalGroup.label": "Flyt til {group}",
  "fieldlistmenu.edit.label": "Rediger mark",
  "fieldlistmenu.delete.label": "Slet mark",
  "fieldlistmenu.moveIn.label": "Flyt dyr til marken",
  "fieldlistmenu.moveIn.tooltip.silage":
    "Du kan ikke flytte dyr til en ensilagemark. Vi behandler marker, der ikke er tilknyttet en dyregruppe, som ensilagemarker.",
  "fieldlistmenu.moveIn.tooltip.sameField":
    'For at flytte dine dyr til en anden mark, vælg den mark, du vil flytte dyrene til, og klik på "Flyt dyr hertil"',
  "confirmdeletedialog.cancel.label": "Annuller",
  "confirmdeletedialog.confirm.label": "Slet",
  "confirmationdeletedialog.animalGroup.title": "Slet dyregruppe",
  "confirmationdeletedialog.animalGroup.description":
    'Er du sikker på, at du vil slette "{name}"?',
  "confirmDeleteFieldDialog.text": "Du vil slette {fieldName}. Er du sikker?",
  "confirmDeleteFieldDialog.title": "Slet mark",
  "confirmcanceldialog.cancel.label": "Fortsæt redigering",
  "confirmcanceldialog.confirm.label": "Kassér ændringer",
  "confirmcanceldialog.text":
    "Hvis du annullerer nu, mister du alle ændringer. Er du sikker?",
  "confirmcanceldialog.title": "Kassér ændringer",
  "toolbar.farmview.title": "Bedrift",
  "toolbar.fieldview.title": "Markdetaljer",
  "toolbar.grasstype-reseeding.title": "Græstype og gensåning",
  "map.cursorTooltip.unit": "kgTS/ha",
  "hint.welcome.title": "Velkommen ",
  "hint.welcome.text": "Klik på + for at oprette din første mark",
  "hint.animalGroups.title": "Tilføj dyregruppe ",
  "hint.animalGroups.text": "Klik på + for at oprette din første gruppe",
  "animalGroup.menu.edit": "Rediger dyregruppe",
  "animalGroup.menu.delete": "Slet dyregruppe",
  "animalGroup.groupWeight": "Samlet vægt af dyregruppe",
  "animalGroup.groupDemand": "Behov",
  "animalGroup.noFieldsAssigned": "Ingen marker tilføjet endnu",
  "animalGroup.demandUnit": "{demandPerHaAndDay} kgTS/ha/dag",
  "animalGroup.animalCount": "Antal dyr i dyregruppe",
  "animalGroupInput.boundary.error": "Noget gik galt",
  "animalGroupInput.addStockClass": "tilføj endnu en dyrekategori",
  "animalGroupInput.demand":
    "{groupDemandInKg} kgTS ({groupDemandInPercent}%) pr. dag",
  "animalGroupInput.stockClasses": "Dyrekategorier",
  "animalGroupInput.stockClasses.birthingPeriods": "Lamning/kælvning detaljer",
  "animalGroupInput.stockClasses.birthingPeriods.dateStart": "Start",
  "animalGroupInput.stockClasses.birthingPeriods.dateEnd": "Slut",
  "animalGroupInput.stockClasses.birthingPeriods.expectedNumAnimalsWithoutPregnancy":
    "Antal ikke-drægtige dyr ",
  "animalGroupInput.stockClasses.birthingPeriods.expectedNumOffspringPerAnimal":
    "Forventet antal kalve/lam pr. dyr",
  "animalGroups.overview.demand": "Behov: {demand} kgTS/ha/dag",
  "animalGroups.overview.availableDryMatter":
    "Tilgængeligt tørstof: {availableDryMatter} kgTS",
  "animalGroups.overview.averageCover": "TS-tæthed: {averageCover} kgTS/ha",
  "toolbar.animalGroupView.title": "Dyregruppe",
  "silage.title": "Ensilage",
  "silage.description": "TS-tæthed: {averageCover} kgTS/ha",
  "grassWedge.open": "Åbn Grass Wedge",
  "units.kilogramPerHectar": "kgTS/ha",
  "units.days": "dage",
  "grassWedge.postGrazingTarget": "Mål efter afgræsning",
  "grassWedge.preGrazingTarget": "Beregnet mål før afgræsning",
  "grassWedge.rotationLength": "Rotationslængde",
  "grassWedge.averageCover": "Gennemsnitligt tørstof kgTS/ha",
  "grassWedge.demand": "Foderbehov kgTS/ha/dag",
  "grassWedge.growth": "Vækstrate kgTS/ha/dag",
  "grassWedge.grazingDaysAhead": "Tilbageværende græsningsdage",
  "grassWedge.tooltip.area": "Areal: {area} {unit}",
  "grassWedge.tooltip.availableDM": "Gennemsnitligt tørstof: {dm} kgTS/ha",
  "grassWedge.tooltip.grazindDaysAhead":
    "Tilbageværende græsningsdage: {days}d {hours}t",
  "grassWedge.noFields.prompt":
    "Tilknyt mindst to marker for at bruge Grass Wedge",
  "grassWedge.singleField.prompt":
    "Tilknyt en anden mark for at bruge Grass Wedge",
  "fieldlistmenu.notification.movedAnimalGroup":
    "{fieldName} blev tilknyttet {animalGroupName}",
  "fieldlistmenu.notification.movedToSilage":
    "{fieldName} blev tilknyttet ensilage",
  "fieldlistmenu.notification.moveFailed": "{fieldName} kunne ikke tilknyttes",
  "fieldlistmenu.notification.editFailed": "{fieldName} kunne ikke redigeres",
  "fieldlistmenu.notification.moveInFailed":
    "Dyrene kunne ikke flyttes til {fieldName}",
  "fieldlistmenu.notification.moveInSuccess": "Dyr blev flyttet til {Feldname}",
  "grassWedge.assignField": "Tilknyt mark",
  "grassWedge.settings": "Indstillinger",
  "grassWedge.title": "Grass Wedge",
  "grassWedge.legend.dryMatter": "Tørstof",
  "grassWedge.legend.demandLine": "Foderbehovsmål",
  "grassWedge.legend.demandLineTooltip":
    "Viser det ideelle græsdække ved hver position i afgræsningsrotationen baseret på dine indstillinger",
  "animalGroup.assignField": "Tilknyt mark",
  "animalGroup.viewFeedAllocation": "Vis foderfordeling",
  "animalGroup.viewRotations": "Vis rotationer",
  "rotationTimeline.title": "Rotationstidslinje",
  "rotationTimeline.current": "Aktuel",
  "rotationTimeline.shed": "Stald",
  "rotationTimeline.move": "Flytning #{number}",
  "rotationTimeline.empty": "Ingen flytninger registreret endnu",
  "rotationTimeline.fieldDeleted": "- (mark slettet)",
  "rotationGrid.season": "Sæson",
  "rotationGrid.rotation": "Rotation {number}",
  "rotationGrid.status.accepted": "Accepteret",
  "rotationGrid.status.proposed": "Foreslået",
  "rotationGrid.origin.farmer": "Brugerinput",
  "rotationGrid.origin.satellite": "Satellitregistreret",
  "rotationGrid.accept": "Acceptér",
  "rotationGrid.reject": "Afvis",
  "rotationGrid.delete": "Slet",
  "rotationGrid.preCover": "Dække før afgræsning",
  "rotationGrid.postCover": "Dække efter afgræsning",
  "rotationGrid.notAssigned": "ikke tilknyttet i øjeblikket",
  "rotationGrid.assignedTo": "I øjeblikket tilknyttet {name}",
  "rotationGrid.assignedFields": "I øjeblikket tilknyttet",
  "rotationGrid.otherFields": "Andre marker",
  "rotationGrid.shed": "Til stalden",
  "rotationGrid.dateOrderError": "Slutdato skal være på eller efter startdato",
  "rotationGrid.dateInRequired": "Græsning startdato er påkrævet",
  "rotationGrid.dateRequiredForPreCover":
    "Angiv græsning startdato for at gemme biomasse før græsning",
  "rotationGrid.dateRequiredForPostCover":
    "Angiv græsning slutdato for at gemme biomasse efter græsning",
  "rotationGrid.attach": "Tilknyt denne gruppe",
  "rotationGrid.editTime": "Rediger tidspunkt",
  "rotationGrid.hideTime": "Skjul tidspunkt",
  "rotationGrid.unattachedTitle": "Hvorfor er denne hændelse ikke tilknyttet?",
  "rotationGrid.unattachedExplanation":
    "Tilknytning af dyregrupper til individuelle afgræsningshændelser blev indført i maj 2024. Ældre hændelser har derfor ikke denne forbindelse. Hvis denne gruppe afgræssede her, så tilknyt hændelsen for at inkludere den i rotationen.",
  "rotationGrid.days": "Dage",
  "rotationGrid.flaggedTooltip":
    "Denne hændelse ser usædvanligt lang ud — kontrollér, om dyrene rent faktisk blev flyttet",
  "rotationGrid.missingMoveIn":
    "Der mangler en indflytningstid. Hvornår flyttede dyrene ind?",
  "rotationGrid.flaggedWarning":
    "Usædvanligt lang afgræsning — mulig glemt flytning eller datafejl",
  "rotationGrid.flaggedSuggestion":
    "Overvej at afslutte denne hændelse den {suggestedEnd} (~{days} dage er almindeligt)",
  "rotationGrid.addEventHint": "Ingen afgræsningshændelse registreret. Tilføj?",
  "rotationGrid.suggestedDates": "Foreslåede datoer:",
  "rotationGrid.addSuggested": "Tilføj med foreslåede datoer",
  "rotationGrid.addEvent": "Tilføj afgræsningshændelse",
  "rotationGrid.ongoing": "igangværende",
  "rotationGrid.warningCrossYear":
    "{field}: Hændelse strækker sig over år — kontrollér datoer",
  "rotationGrid.useEndDate": "Afslut den {date}",
  "rotationGrid.edit": "Rediger",
  "rotationGrid.duplicateTooltip":
    "{count} overlappende hændelser — klik for at rydde op",
  "rotationGrid.duplicateWarning":
    "{count} overlappende hændelser for samme datoer",
  "rotationGrid.removeDuplicates": "Fjern {count} duplikat(er)",
  "rotationGrid.health.title": "Rotationssundhed",
  "rotationGrid.health.noClashes": "Ingen tidskonflikter",
  "rotationGrid.health.clashes": "{count} tidskonflikt(er)",
  "rotationGrid.health.avgGrazing": "Ø {days}d pr. mark",
  "rotationGrid.health.recovery": "Ø restitution: {days}d",
  "rotationGrid.health.recoveryTarget": "Mål: {days}d",
  "rotationGrid.health.pathCoverage":
    "{count} af {total} hændelser passer til rotationen",
  "rotationGrid.health.outliers": "Vis {count} afvigere",
  "rotationGrid.conflict.banner":
    "{count} overlappende hændelse(r) — dyr kan kun være på én mark ad gangen",
  "rotationGrid.conflict.review": "Gennemgå & løs",
  "rotationGrid.conflict.stepOf": "Konflikt {step} af {total}",
  "rotationGrid.conflict.question":
    "Den {date} blev dyr registreret på to marker. Hvilken er korrekt?",
  "rotationGrid.conflict.resolved": "Alle konflikter løst!",
  "rotationGrid.conflict.resolvedDetail":
    "Din rotationsoversigt er nu ren og konsistent.",
  "review.title": "Færdiggør registreringer",
  "review.looksRight": "Korrekt",
  "review.notRight": "Ikke korrekt",
  "review.allDone": "Alt klart!",
  "review.allDoneDetail": "Din rotationsoversigt er opdateret.",
  "review.sameDay": "{count} hændelser den {date} har brug for tidsjustering",
  "review.applyFix": "Anvend foreslåede tidspunkter",
  "review.missingFields": "Sprunget over: {fields}{more}",
  "review.addMissing": "Tilføj {fields}{more}",
  "review.skippedHint": "{count} mark(er) ikke besøgt",
  "review.pickField": "Hvilken mark?",
  "review.enterDates": "Hvornår var dyrene her?",
  "rotationGrid.emptyYear": "Ingen afgræsningsdata for {year}",
  "rotationGrid.emptyYearHint":
    "Flyt dine dyr mellem marker for at opbygge din rotationshistorik.",
  "rotationGrid.clash.warning":
    "Overlap med {field} på {days} dag(e) — dyr kan kun være på én mark",
  "rotationGrid.outlier.tooltip":
    "Passer sandsynligvis ikke ind i hovedrotationen",
  "rotationGrid.outlier.remove": "Fjern afviger",
  "rotationGrid.estimate.days": "~{days}d est.",
  "rotationGrid.recovery.label": "Restitution: {days}d",
  "rotationGrid.recovery.insufficient":
    "Restitution for kort ({days}d, kræver {target}d)",
  "rotationGrid.suggested.label": "Foreslået",
  "rotationGrid.editDateIn": "Afgræsningsstart",
  "rotationGrid.editDateOut": "Afgræsningsslut",
  "grassWedge.notification.saved": "Gemt",
  "grassWedge.notification.error": "Noget gik galt.",
  "assignFieldDialog.title": "Tilknyt mark til denne dyregruppe",
  "assignFieldDialog.inputLabel": "Mark",
  "assignFieldDialog.nofieldsLabel": "Ingen marker tilgængelige",
  "assignFieldDialog.button": "Tilknyt",
  "setCurrentFieldDialog.title": "Angiv aktuel placering",
  "setCurrentFieldDialog.inputLabel": "Vælg den mark, hvor dyrene er",
  "setCurrentFieldDialog.noFieldsLabel": "Ingen marker tilknyttet denne gruppe",
  "setCurrentFieldDialog.button": "Angiv",
  "setCurrentFieldDialog.setButton": "Angiv",
  "animalGroupInput.add.success": "{animalGroupName} tilføjet",
  "animalGroupInput.edit.success": "{animalGroupName} opdateret",
  "animalGroupSetup.step1.title": "Ny dyregruppe",
  "animalGroupSetup.step1.subtitle":
    "Giv denne gruppe et navn – for eksempel en flok, der flytter og græsser sammen.",
  "animalGroupSetup.step1.continue": "Fortsæt",
  "animalGroupSetup.step2.title": "Tilføj dyr",
  "animalGroupSetup.step2.subtitle":
    "Tilføj dyrene i denne gruppe. De danner dit foderbudget – din plan over græsudbud mod foderbehov.",
  "animalGroupSetup.step2.empty": "Ingen dyr tilføjet endnu.",
  "animalGroupSetup.step2.addAnimalType": "Tilføj dyretype",
  "animalGroupSetup.step2.finish": "Afslut",
  "animalGroupSetup.step2.remove": "Fjern",
  "animalGroupSetup.preparing": "Opsætter foderbudget…",
  "animalGroupSetup.building.caption":
    "Opretter foderbudget for din dyregruppe…",
  "animalGroupSetup.building.demandLabel": "Aktuelt dagligt foderbehov",
  "animalGroupSetup.building.budgetLabel": "Foderbehov gennem året",
  "animalGroupSetup.building.viewBudget": "Vis fuldt foderbudget",
  "animalGroupSetup.fromMonth": "Fra {month}",
  "fieldInput.add.success": "{fieldName} tilføjet",
  "fieldInput.edit.success": "{fieldName} opdateret",
  "farmInput.add.success": "{farmName} tilføjet",
  "animalGroup.grassWedgeButton.tooltip":
    "Mindst to marker med tørstof er påkrævet",
  "fieldProposedEventsModal.headline": "Nye hændelser",
  "fieldProposedEventsModal.description":
    "Acceptér eller afvis de automatisk registrerede afgræsnings- eller slåningshændelser nedenfor for at opdatere dine værdier.",
  "fieldProposedEventsModal.description1":
    "ruumi registrerer nu, hvornår en mark sidst blev afgræsset eller slået. Dette sker ved hjælp af satellitradar, der flyver forbi hver 2.-3. dag og trænger gennem skydækket. Lige nu tilføjes forslag til afgræsningshændelser til din markhistorik, hvis du accepterer eller afviser dem.",
  "fieldProposedEventsModal.description2":
    "Tryk på 'flueben'-knappen, hvis du mener, at ruumi har ret, eller på 'kryds'-knappen, hvis ikke. Med 'blyant'-knappen kan du tilføje ind- og udsætningstider samt dække før og efter afgræsning. Brug 'plus'-knappen til at tilføje en ny hændelse til marken.",
  "fieldProposedEventsModal.description3":
    "Som standard nulstiller ruumi marker efter afgræsning til 1500 kg TS/ha eller til den restværdi, du angiver i gruppens Grass Wedge.",
  "fieldProposedEventsModal.description4":
    "Du kan også finde registrerede hændelser, hvis du klikker på en mark og kigger i nederste venstre hjørne.",
  "fieldProposedEventsModal.close": "Luk",
  "fieldProposedEventsModal.help": "Hjælp",
  "certificationProgramApplicationModal.headline":
    "ruumi certificeringsprogram",
  "certificationProgramApplicationModal.description":
    "Ved at bruge ruumi opbygger du et omfattende datasæt over dine landbrugsaktiviteter. Vi kan bruge disse data til at skabe de mest værdifulde kulstofkreditter. Klik nedenfor for at ansøge om vores certificeringsprogram for kulstofkreditter.",
  "certificationProgramApplicationModal.cta": "Tilmeld ruumi CO2-certifikater",
  "carbon.profile.cta.text":
    "Find ud af, hvordan du kan finansiere omstillingen til regenerative metoder - ",
  "carbon.profile.cta.link": "<Link>book en gratis rådgivning</Link>.",
  "after_first_field_created.field.dialog.title": "Tillykke!",
  "after_first_field_created.field.dialog.text":
    "Du kan nu tegne flere marker eller tilføje dyregrupper og tilknytte dem til markerne. Så er det tid til at lade dyrene græsse!",
  "after_field_created.field.dialog.text": "Mark oprettet!",
  "after_field_created.field.dialog.close": "Luk",
  "after_field_created.field.dialog.anotherField": "Tegn endnu en mark",
  "after_field_created.field.dialog.addAnimalGroup": "Tilføj dyregruppe",
  "map.postcodeInput.placeholder": "8000",
  "map.postcodeInput.helperText": "Naviger til bedriftens postnummer",
  "newSignup.userDetails.alreadyRegistered":
    "Allerede registreret? <a>Log ind her</a>.",
  "passwordForgot.dialog.title": "Glemt adgangskode",
  "passwordForgot.mail.label": "E-mail",
  "passwordForgot.button.label": "Nulstil adgangskode",
  "passwordForgot.success":
    "Gode nyheder! Vi har sendt dig en e-mail med instruktioner til at nulstille din adgangskode. Tjek venligst din indbakke.",
  "passwordForgot.success.2":
    "Hvis du ikke kan finde den, så tøv ikke med at kontakte os på hello@ruumi.io, så hjælper vi dig gerne.",
  "passwordForgot.failure":
    "Kunne ikke sende e-mail til din adresse. Kontakt os venligst på hello@ruumi.io.",

  "passwordReset.userDetails.text1": "Indstil din nye adgangskode",
  "passwordReset.userDetails.dialogTitle": "Nulstil adgangskode",
  "passwordReset.linkInvalid":
    "Linket er ugyldigt eller udløbet. Anmod om et nyt link.",
  "passwordReset.requestNewLink": "Anmod om et nyt link",
  "passwordReset.button.label": "Nulstil adgangskode",
  "passwordChange.failure": "Det lykkedes ikke at ændre adgangskoden",

  "defaultStockClass.DAIRY_COW": "Malkeko",
  "defaultStockClass.DAIRY_COW_2_KGMS": "Malkeko (2 kgMS)",
  "defaultStockClass.DAIRY_COW_2_KGMS.notes":
    "2kgMS = ~28l @ 7,5% mælketørstof - laktationstop",
  "defaultStockClass.SUCKLER_COW": "Ammeko",
  "defaultStockClass.SUCKLER_COW.notes":
    "inklusive kalv op til 200 dage gammel",
  "defaultStockClass.GROWING_CATTLE": "Voksende kvæg",
  "defaultStockClass.EWE": "Moderfår",
  "defaultStockClass.EWE_TWINS": "Moderfår (tvillinger)",
  "defaultStockClass.EWE_TWINS.notes": "inklusive lam op til 100 dage gamle",
  "defaultStockClass.WEANED_LAMB": "Fravænnet lam",

  "defaultFeeding.DRY_MAINTENANCE": "Tør - vedligehold",
  "defaultFeeding.THIRTY_DAYS_PRE_CALVING": "30 dage før kælvning",
  "defaultFeeding.LTE_2_MONTHS_POST_CALVING": "0-2 måneder efter kælvning",
  "defaultFeeding.GT_2_MONTHS_POST_CALVING": ">2 måneder efter kælvning",
  "defaultFeeding.DRY_MAINTENANCE_BCS_GAIN": "Tør - vedligehold + BCS-tilvækst",
  "defaultFeeding.GTE_3_LTE_4_MONTHS_POST_CALVING":
    "3-4 måneder efter kælvning",
  "defaultFeeding.GT_4_MONTHS_POST_CALVING":
    ">4 måneder efter kælvning indtil fravænning",
  "defaultFeeding.GT_4_MONTHS_POST_CALVING.notes":
    "inklusive kalv op til 200 dage gammel",
  "defaultFeeding.MAINTENANCE": "Vedligehold",
  "defaultFeeding.MAINTENANCE_500G_DLWG": "Vedligehold + 0,5 kg DLWG",
  "defaultFeeding.MAINTENANCE_1KG_DLWG": "Vedligehold + 1 kg DLWG",
  "defaultFeeding.MAINTENANCE_GT_1KG_DLWG": "Vedligehold + >1 kg DLWG",
  "defaultFeeding.THIRTY_DAYS_PRE_LAMBING": "30 dage før lamning",
  "defaultFeeding.LTE_1_MONTHS_POST_LAMBING": "0-1 måned efter lamning",
  "defaultFeeding.GT_1_MONTH_POST_LAMBING_TO_WEANING":
    ">1 måned efter lamning indtil fravænning",
  "defaultFeeding.GT_1_MONTH_POST_LAMBING_TO_WEANING.notes":
    "inklusive lam op til 100 dage gamle",
  "defaultFeeding.MAINTENANCE_50G_DLWG": "Vedligehold + 50 g DLWG",
  "defaultFeeding.MAINTENANCE_150G_DLWG": "Vedligehold + 150 g DLWG",
  "defaultFeeding.MAINTENANCE_GT_150G_DLWG": "Vedligehold + >150 g DLWG",
  "stockClassDemandTemplateAutocomplete.customValue": 'Brug "{inputValue}"',
  "stockClassDemandTemplateAutocomplete.listItemTitle":
    "{stockClassName} — {allocatedBodyWeightFraction}% LV",
  "common.reloadPage":
    "Grazing-appen er blevet opdateret, ny version indlæses, vent venligst",
  "moveOut.updateCover": "Opdater dække på {name}?",
  "moveOut.fromField": "Fra mark: {fieldName}",
  "moveOut.toField": "Til mark: {fieldName}",
  "moveOut.title": "Dyr flyttes",
  "moveOut.date.label": "Dato",
  "moveOut.minDateInfo":
    "Denne dyregruppe blev senest flyttet den {minDate}. Den valgte dato skal være efter dette.",
  "moveOut.subTitle": "Ændr dække på {fieldName} fra {currentCover} kgTS/ha",
  "moveOut.subTitle2": "til",
  "moveOut.postCover.label": "Nyt dække",
  "moveOut.leaveIt.label": "Opdater ikke dække",
  "moveOut.changeIt.label": "Opdater dække",
  "moveAnimals.titlePrefix": "Flyt gruppe:",
  "moveAnimals.date.label": "Hvornår blev der flyttet?",
  "moveAnimals.from.label": "Hvor er dyrene nu?",
  "moveAnimals.to.label": "Hvor flyttes de hen?",
  "moveAnimals.postGrazingCover.label": "Dække efter afgræsning",
  "moveAnimals.preGrazingCover.label": "Dække før afgræsning",
  "moveAnimals.coverLeaving.label": "Dække ved afgang",
  "moveAnimals.coverArriving.label": "Dække ved ankomst",
  "moveAnimals.useTarget": "Brug {value}",
  "moveAnimals.change": "Skift",
  "moveAnimals.validation.range":
    "Angiv et realistisk dække ({min}–{max} kgDM/ha)",
  "moveAnimals.validation.belowStart":
    "Bør være under dækket før afgræsning ({value} kgDM/ha)",
  "moveAnimals.validation.lowUtilisation":
    "Næsten ikke afgræsset – tjek restdække",
  "moveAnimals.validation.fix":
    "Ret venligst de fremhævede dækker før du gemmer",
  "moveAnimals.dmUtilised": "≈ {value} kg DM optaget",
  "moveAnimals.dmUtilisedWithHead":
    "≈ {value} kg DM optaget ({perHead} kg/dyr/dag)",
  "moveAnimals.grazingStarted":
    "fra {pre} kgDM/ha over {days, plural, one {# dag} other {# dage}}",
  "moveAnimals.cancel": "Annuller",
  "moveAnimals.submit": "Flyt dyr",
  "moveAnimals.noFields": "Ingen marker tilgængelige",
  "farmView.button.grasstype-reseeding.title": "Græstype og gensåning",
  "reseedingDetailView.button.addReseedingEvent.title":
    "Tilføj ny gensåningshændelse",
  "reseedingDetailView.button.updateGrassTypes.title": "Opdater græstyper",
  "reseedEvent.field": "{name}",
  "reseedEvent.note": "Note: {note}",
  "reseedEvent.seedingMethod": "Metode: {seedingMethod}",
  "reseedEvent.to": "Til: {newGrassType}",
  "reseed.date.method.heading": "Dato, metode & græstype",
  "reseedEvent.list.title": "Tidligere hændelser",
  "reseedEvent.menu.editView": "Rediger/vis",
  "reseedEvent.seedingMethod.option.PLOUGH_AND_POWER_HARROW":
    "Plov og rotorharve",
  "reseedEvent.seedingMethod.option.DIRECT_DRILL": "Direktesåning",
  "reseedEvent.seedingMethod.option.SHALLOW_CULTIVATION":
    "Overfladisk jordbehandling",
  "reseedEvent.seedingMethod.option.OVERSEED": "Eftersåning",
  "reseedEvent.seedingMethod.option.PLOUGH_POWER_HARROW_DRILL":
    "Pløjning → rotorharve & såmaskine",
  "reseedEvent.seedingMethod.option.PLOUGH_SHALLOW_CULTIVATE_DRILL":
    "Pløjning → tallerken-/tand-kultivator & såmaskine",
  "reseedEvent.seedingMethod.option.PLOUGH_CULTIPACK_SEED":
    "Pløjning → cultipacker-såning",
  "reseedEvent.seedingMethod.option.PLOUGH_DIRECT_DRILL":
    "Pløjning → direktesåning",
  "reseedEvent.seedingMethod.option.SHALLOW_CULTIVATE_DRILL":
    "Tallerken-/tand-kultivator & såmaskine",
  "reseedEvent.seedingMethod.option.DIRECT_DRILL_RESEED":
    "Direktesåning (pløjefri nyanlæg)",
  "reseedEvent.seedingMethod.option.DIRECT_DRILL_OVERSEED":
    "Direktesåning eftersåning",
  "reseedEvent.seedingMethod.option.TINE_DRILL_OVERSEED":
    "Græsstrigle med eftersåning",
  "reseedEvent.seedingMethod.option.BROADCAST_OVERSEED":
    "Bredsåning eftersåning",
  "reseedEvent.seedingMethod.option.FROST_SEEDING": "Frostsåning",
  "reseedEvent.seedingMethod.text": "Metode",
  "diaryEntry.diaryEntryText.label": "Dagbogsindlæg: {diaryEntryText}",
  "diaryEntry.show.titleName": "Dagbogsindlæg",
  "diaryEntry.entryDate.label": "Dato {diaryEntryDate}",
  "diaryEntry.entryDate.text": "Dato",
  "diaryEntry.notes.label": "Noter",
  "diaryEntry.selectImage.button": "Vælg billede",
  "diaryEntry.takePhoto.button": "Tag foto",
  "diaryEntry.fieldSelect.label": "Marker",
  "otherEventInput.title": "Anden hændelse",
  "addOtherEvent.add.success": "Ny hændelse tilføjet",
  "addOtherEvent.update.success": "Hændelse opdateret",
  "diaryEntry.showImage.title": "Dagbogsindlæg fra {diaryEntryDate}",
  "diaryEntry.delete.label": "Slet",
  "diaryEntry.delete.confirm.label": "Ja",
  "diaryEntry.cancel.label": "Annuller",
  "diaryEntry.areYouSure.label":
    "Er du sikker på, at du vil slette dette indlæg?",
  "diaryEntry.view.delete.menu": "Vis/slet",
  "diaryEntry.view.menu": "Vis",
  "diaryEntry.view.close.label": "Luk",
  "diaryEntry.deleted.notification": "Dagbogsindlæg slettet.",
  "diaryEntry.delete.tooltip": "Slet dagbogsindlæg",
  "go.to.landmanagement.and.grazing.button": "Bedrift",
  "go.to.records": "Registreringer",
  "toolbar.records.view": "Registreringer",
  "inputs.outputs.reseeding.title": "Genså",
  "home.button.title": "Hjem",
  "pushNotification.fileShare.title": "Ny fil delt",
  "pushNotification.fileShare.message":
    "{uploaderName} har delt en fil med dig: {fileName}",
  "pushNotification.fileShare.dismiss": "Luk",
  "pushNotification.fileShare.viewFiles": "Vis filer",
  "forceUpgrade.title": "Opdatering påkrævet",
  "forceUpgrade.message":
    "En ny version af Ruumi er tilgængelig. Opdater appen for at fortsætte.",
  "forceUpgrade.updateButton": "Opdater nu",
  "softUpgrade.title": "Opdatering tilgængelig",
  "softUpgrade.message":
    "En ny version af Ruumi med forbedringer og fejlrettelser er tilgængelig.",
  "softUpgrade.updateButton": "Opdater nu",
  "softUpgrade.dismissButton": "Ikke nu",
  "common.additionalDetails.heading": "Yderligere oplysninger (valgfrit)",

  // Signup onboarding steps
  "signup.teaser.dialogTitle": "Kom i gang",
  "signup.teaser.text":
    "Start din gratis 60-dages prøveperiode i dag. Indtast marker og få indsigt på få sekunder.",
  "signup.userDetails.dialogTitle": "Kontooplysninger",
  "signup.userDetails.text":
    "Ingen betaling påkrævet i dag. Kun dine kontaktoplysninger, så vi kan oprette din konto.",
  "signup.farmDetails.dialogTitle": "Bedriftsdetaljer",
  "signup.farmDetails.text":
    "For at give dig den bedst mulige service, fortæl os hvilken type bedrift du driver.",
  "signup.welcome.newTitle": "Velkommen til Ruumi!",
  "signup.welcome.newSubtitle":
    "Lad os sætte din bedrift op i få enkle trin. Vi guider dig gennem hvert enkelt.",
  "signup.welcome.step1": "Opret din bedrift og angiv dens placering",
  "signup.welcome.step2": "Tegn dine marker på kortet",
  "signup.welcome.step3": "Tilføj dine dyregrupper",
  "signup.welcome.step4": "Begynd at planlægge dine rotationer",
  "signup.welcome.helpText": "Brug for hjælp? Vi er her for dig.",

  // Onboarding checklist
  "onboarding.checklist.title": "Bedriftsopsætning",
  "onboarding.checklist.progress": "{completed} af {total} gennemført",
  "onboarding.checklist.dismiss": "Skjul tjekliste",
  "onboarding.checklist.show": "Vis opsætnings-tjekliste",
  "onboarding.checklist.watchVideo": "Se tutorial",
  "onboarding.step.createFarm.title": "Opret bedrift",
  "onboarding.step.createFarm.description":
    "Indstil dit bedriftsnavn og placering for at komme i gang.",
  "onboarding.step.createFarm.action": "Opret bedrift",
  "onboarding.step.addField.title": "Tilføj første mark",
  "onboarding.step.addField.description":
    "Tegn markgrænser på kortet. Vi beregner græsdækket automatisk.",
  "onboarding.step.addField.action": "Tilføj mark",
  "onboarding.step.createAnimalGroup.title": "Opret dyregruppe",
  "onboarding.step.createAnimalGroup.description":
    "Tilføj din besætning for at følge afgræsningsbehovet.",
  "onboarding.step.createAnimalGroup.action": "Tilføj dyr",
  "onboarding.step.assignField.title": "Tilknyt marker til dyr",
  "onboarding.step.assignField.description":
    "Forbind marker med din dyregruppe for at starte rotationsplanlægning.",
  "onboarding.step.assignField.action": "Tilknyt marker",
  "onboarding.completion.title": "Alt klar!",
  "onboarding.completion.message":
    "Din bedrift er klar. Begynd at følge græsvæksten og planlæg rotationer for at optimere din afgræsning.",
  "onboarding.completion.helpText": "Har du spørgsmål eller brug for hjælp?",
  "onboarding.completion.helpLink": "Kontakt os",
  "onboarding.completion.button": "Lad os komme i gang!",

  // Map hints
  "map.movingHandles.hint":
    "Flyt punkterne eller dobbeltklik på markpunkter for at vælge dem.",

  // Farm livestock
  "farm.livestock.label": "Besætning",
  "farm.livestock.addAnimalGroup": "Tilføj dyregruppe",
  "animalGroupTypeCards.addMoreAnimalGroups": "+ TILFØJ DYREGRUPPE",

  // Animal group metrics
  "animalGroup.metrics.title": "Dyregruppe-nøgletal",
  "animalGroup.metrics.animals": "Dyr",
  "animalGroup.metrics.currentField": "Aktuel placering",
  "animalGroup.metrics.notSet": "Ikke angivet",
  "animalGroup.metrics.assignedFields": "Tilknyttede marker",
  "animalGroup.metrics.assignedArea": "Tilknyttet areal",
  "animalGroup.metrics.assignedArea.info":
    "Samlet areal af alle marker tilknyttet denne dyregruppe.",
  "animalGroup.metrics.stockingRate": "Belægningsgrad",
  "animalGroup.metrics.stockingRate.info":
    "Storkreaturenheder pr. hektar. Beregnet som samlet SKE divideret med tilknyttet areal.",
  "animalGroup.metrics.grazingDaysAhead": "Tilbageværende græsningsdage",
  "animalGroup.metrics.grazingDaysAhead.info":
    "Tilbageværende græsningsdage baseret på aktuelt foderudbud og dagligt foderbehov.",
  "animalGroup.metrics.dailyFeedDemand": "Dagligt foderbehov",
  "animalGroup.metrics.dailyFeedDemand.info":
    "Samlet dagligt tørstofforbrug for alle dyr i gruppen.",
  "animalGroup.metrics.animalCount.info":
    "Samlet antal dyr i gruppen. SKE (storkreaturenheder) omregner forskellige dyretyper til en standardenhed, hvor 1 SKE = 1 malkeko.",
  "animalGroup.metrics.forageAvailable.info":
    "Samlet tilgængeligt tørstof på alle tilknyttede marker over efter-afgræsningsmålet.",
  "animalGroup.metrics.none": "Ingen",
  "animalGroup.metrics.stockClasses": "Dyrekategorier",
  "animalGroup.metrics.stockClasses.info":
    "Dyreantal og foderallokering styres i foderbudgetplanlæggeren. Åbn foderbudgettet for at redigere dem.",
  "animalGroup.metrics.dryMatterAvailable": "TS tilgængeligt",
  "animalGroup.metrics.dryMatterAvailableUnit": "kgTS",
  "animalGroup.metrics.forageAvailable": "Tilgængeligt foder",
  "animalGroup.currentFieldNotSet": "Aktuel afgræsningsmark ikke angivet",
  "animalGroup.setCurrentField": "Angiv mark",
  "animalGroup.moveToShed": "Flyt i stald",
  "animalGroup.moveToShed.success": "Dyr flyttet i stald",
  "animalGroup.moveToShed.error": "Dyrene kunne ikke flyttes i stalden",
  "moveAnimals.moveConflict":
    "Denne flytning er i konflikt med en nyere ændring. Opdater, og prøv igen.",

  // Field type cards
  "fieldTypeCards.grain.title": "Kornmarker",
  "fieldTypeCards.arable.title": "Agermarker",
  "fieldTypeCards.silage.title": "Ensilagemarker",
  "fieldTypeCards.pasture.title": "Græsmarker",
  "farm.fields.label": "Marker",
  "farm.fields.addField": "Tilføj mark",
  "fieldTypeCards.addMoreFields": "+ TILFØJ FLERE MARKER",
  "fieldTypeCards.noFields": "Ingen marker",
  "fieldTypeCards.metrics.fields": "Marker",
  "fieldTypeCards.metrics.hectares": "Ha",
  "fieldTypeCards.metrics.dryMatterAvailable": "TS tilgængeligt",
  "fieldTypeCards.metrics.dryMatterAvailableUnit": "kgTS",
  "fieldTypeCards.metrics.growthRate": "Vækstrate",
  "fieldTypeCards.metrics.growthRateUnit": "kgTS/ha/dag",
  "fieldTypeCards.metrics.totalCover": "TS-tæthed",
  "fieldTypeCards.metrics.totalCoverUnit": "kgTS/ha",

  // Field prefixes
  "field.prefix.grazing": "Græsmark",
  "field.prefix.silage": "Ensilagemark",
  "field.prefix.grain": "Kornmark",
  "field.prefix.arable": "Agermark",

  // Farm add menu
  "farm.addMenu.inputs": "Tilføj input og output",
  "farm.addMenu.farm": "Tilføj bedrift",

  // Reseed event title names
  "reseedEvents.show.titleName.RESEED": "{name} gensået",
  "reseedEvents.show.titleName.OVERSEED": "{name} eftersået",

  // Grass wedge tooltip
  "grassWedge.tooltip.currentDM": "TS-tæthed: {dm} kgTS/ha",

  // Field view livestock
  "fieldview.livestock.noAnimalGroupAssigned": "Ingen dyregruppe tilknyttet",
  "fieldview.livestock.assignAnimalGroupDescription":
    "Tilknyt en dyregruppe til denne mark for at se besætningsoplysninger",
  "fieldview.livestock.assignNewGroup": "TILKNYT NY GRUPPE",
  "fieldview.livestock.title": "Dyr",
  "fieldview.livestock.dryMatterAvailable": "Tilgængeligt tørstof",
  "fieldview.livestock.lastGrazed": "Senest afgræsset",
  "fieldview.livestock.daysAgo": "for {days} dage siden",
  "fieldview.livestock.today": "I dag",
  "fieldview.livestock.currentlyGrazing": "Afgræsser i øjeblikket",
  "fieldview.livestock.currentlyGrazingSinceToday":
    "Afgræsser i øjeblikket (siden i dag)",
  "fieldview.livestock.currentlyGrazingSince1Day":
    "Afgræsser i øjeblikket (1 dag)",
  "fieldview.livestock.currentlyGrazingSinceDays":
    "Afgræsser i øjeblikket ({days} dage)",
  "fieldview.livestock.never": "Aldrig",
  "fieldview.livestock.assignedGroup": "Tilknyttet dyregruppe",
  "fieldview.livestock.change": "Skift",
  "fieldview.livestock.assign": "Tilknyt",
  "fieldview.livestock.currentLocation": "Aktuel placering",
  "fieldview.livestock.notSet": "Ikke angivet",
  "fieldview.livestock.moveHere": "Flyt dyr hertil",
  "fieldview.livestock.assignDialogTitle": "Tilknyt dyregruppe",

  // New signup
  "newSignup.userDetails.text1": "Velkommen til ruumi!",
  "newSignup.userDetails.text2":
    "Registrer dig og brug afgræsningsappen med det samme!",
  "signup.confirmPassword.label": "Bekræft adgangskode",
  "signup.confirmPassword.error": "Adgangskoderne stemmer ikke overens",
  "signup.button.newSignup": "Til appen",
  "signup.signupError":
    "Der opstod en fejl. Denne e-mailadresse er muligvis allerede registreret. Brug venligst en anden, eller kontakt support.",

  // Move animals to/from shed
  "moveAnimals.toShed.title": "Flyt i stald",
  "moveAnimals.fromShed.label": "Fra stald til:",
  "moveAnimals.shed": "Stald",

  // Navigation
  "go.to.programmes": "Planlægning",
  "toolbar.farminsighs.title": "Bedriftsindsigter",
  "go.to.file.management.button": "Filer",
  "go.to.file.management.button.mobile": "Filer",
  "go.to.farmer.dashboards.button": "Program-dashboards",
  "farmer.dashboard.label": "Landmandsdashboard",
  "farmer.dashboard.farmer.selection.label": "Vælg landmand",
  "farmer.dashboard.dashboard.selection.label": "Vælg dashboard",
  "go.to.farm.insights": "Indsigter",
  "go.to.project.insights": "Programmer",
  "go.to.project.insights.mobile": "Programmer",
  "go.to.initial.screen.select": "Bedriftsvisning",
  "go.to.accessible.farms.insights": "Fremskridt",

  // Feed
  "toolbar.feed-overview.title": "Foder",
  "inputs.outputs.feed.purchase.title": "Foder",
  "feedPurchaseDetailView.button.addFeedPurchase.title": "Tilføj nyt foderkøb",
  "feedPurchase.list.title": "Tidligere hændelser",
  "purchased.show.titleName": "Foderkøb: {name}",
  "feedPurchaseEvent.feedPurchaseDate": "Dato: {feedPurchasedDate}",
  "feedPurchaseEvent.feedType.text": "Fodertype",
  "feedPurchase.feedType.option.HAYLAGE": "Wraphø",
  "feedPurchase.feedType.option.SILAGE": "Græsensilage",
  "feedPurchase.feedType.option.MAIZE_SILAGE": "Majsensilage",
  "feedPurchase.feedType.option.WHOLECROP_SILAGE": "Helsædsensilage",
  "feedPurchase.feedType.option.GRAIN": "Korn",
  "feedPurchase.feedType.option.CONCENTRATED_FEED": "Kraftfoder",
  "feedPurchase.feedType.option.STRAW": "Halm",
  "feedPurchase.feedType.option.HAY": "Hø",
  "feedPurchaseEvent.cost.label": "Pris (i DKK)",
  "feedPurchase.feedUnit.option.KG": "Kg",
  "feedPurchase.feedUnit.option.TONNE": "Ton",
  "feedPurchaseEvent.feedUnit.text": "Enhed",
  "feed.stock.summary.header": "Foder på lager",
  "feedPurchaseEvent.menu.editView": "Rediger",
  "feedStock.summary.noFeedAvailable": "Intet foder tilgængeligt",
  "feedPurchaseEvent.feedAmount.label": "Mængde",
  "enterFeedPurchase.heading": "Foderkøb",
  "feedEventInput.removeFeed": "slet",
  "feedEventInput.addFeed": "Tilføj ny fodertype",
  "feedEventInput.title": "Foderhændelse",
  "feedEventInput.note": "Note",
  "feedEventDetailView.button.addFeedEvent.title": "Tilføj ny foderhændelse",
  "feedEventInput.AnimalGroups.text": "Dyregrupper",
  "notEnoughFeed.cancel.label": "Forstået",
  "notEnoughFeed.title": "Ikke nok foder tilgængeligt!",
  "cropTypeMissing.title": "Afgrøde mangler i udbyttelisten",
  "addFeedEvent.add.success": "Ny foderhændelse tilføjet.",
  "reatefeedPurchaseEvent.success": "Ny foderkøbshændelse tilføjet.",
  "feedItem.animalGroups.fedTo": "Fodret til: ",

  // Yield events
  "yieldEvent.yieldType.option.HAYLAGE": "Wraphø",
  "yieldEvent.yieldType.option.SILAGE": "Græsensilage",
  "yieldEvent.yieldType.option.HAY": "Hø",
  "yieldEvent.yieldType.option.STRAW": "Halm",
  "yieldEvent.yieldType.option.MAIZE_SILAGE": "Majsensilage",
  "yieldEvent.yieldType.option.WHOLECROP_SILAGE": "Helsædsensilage",
  "yieldEvent.yieldType.option.WHEAT": "Hvede",
  "yieldEvent.yieldType.option.BARLEY": "Byg",
  "yieldEvent.yieldType.option.OILSEED_RAPE": "Raps",
  "yieldEvent.yieldType.option.POTATO": "Kartofler",
  "yieldEvent.yieldType.option.MAIZ": "Majs",
  "yieldEvent.yieldType.option.CEREALS": "Korn",
  "yieldEvent.yieldType.option.VEGETABLES_SALAD": "Grøntsager/salat",
  "yieldEvent.yieldType.option.OTHERS": "Andet",
  "yieldEvent.yieldType.option.MEAT": "Kød",
  "yieldEvent.yieldType.option.MILK": "Mælk",
  "yieldEvent.yieldType.option.GRASS": "Græs",
  "yieldEvent.yieldType.option.CROP": "Afgrøde",
  "yieldEventInput.title": "Indtast udbytter",
  "yieldEventInput.addYield": "Tilføj endnu et udbytte",
  "yieldEvent.yieldAmount.label": "Mængde",
  "yieldEvent.yieldType.text": "Udbyttetype",
  "inputs.outputs.yield.title": "Udbytter & høster",
  "toolbar.yield-overview.title": "Udbytte",
  "yieldEventDetailView.button.addYieldEvent.title":
    "Tilføj ny udbyttehændelse",
  "yieldEventInput.removeYield": "Fjern udbytte",
  "yieldEvent.yieldType.MEAT": "Kød",
  "yieldEvent.yieldType.MILK": "Mælk",
  "yieldEvent.yieldType.CROP": "Afgrøde",
  "yieldEvent.yieldType.GRASS": "Græs",
  "yieldEvent.soldOrKept.label.SOLD": "Solgt",
  "yieldEvent.soldOrKept.label.KEPT": "Beholdt",
  "yieldEvent.unitType.option.TONNE": "Ton",
  "yieldEvent.unitType.option.KG": "Kg",
  "yieldEvent.unitType.option.LITRE": "Liter",
  "yieldEvent.unitType.option.M3": "M3",
  "yieldEvent.unitType.text": "Enhed",
  "yieldEvent.revenue.label": "Beløb (i DKK)",
  "yieldEvent.soldOrKept.text": "Solgt/beholdt",
  "yieldEvent.fuel.label": "Brændstof (i liter)",
  "yieldEvent.machinery.label": "Maskiner",
  "yieldEventInput.grassFields.text": "Græsmarker",
  "yieldEventInput.animalGroups.text": "Dyregrupper",
  "yieldEventInput.arableFields.text": "Agermarker",
  "yieldEvent.yieldEventDate": "Dato: {yieldEventDate}",
  "yieldEvent.grassFields.harvestedFrom": "Marker: ",
  "yieldEvent.arableFields.harvestedFrom": "Marker: ",
  "yieldEvent.animalGroups.harvestedFrom": "Dyregrupper: ",
  "yieldEvent.amount.sold": "{amount} solgt for {soldPrice}",
  "yieldEvent.amount.kept": "{amount} beholdt",
  "yieldEventInput.machinery.options.SPRAYER": "Sprøjte",
  "yieldEventInput.machinery.options.MOWER": "Slåmaskine",
  "yieldEventInput.machinery.options.SEED_BROADCASTER": "Såmaskine",
  "yieldEventInput.machinery.options.DIRECT_DRILL": "Direkte-såmaskine",
  "yieldEventInput.machinery.options.MANURE_SPREADER": "Møgspreder",
  "yieldEventInput.machinery.options.SLURRY_SPREADER": "Gyllevogn",
  "yieldEventInput.machinery.options.BALER": "Ballepresser",
  "yieldEvent.menu.editView": "Rediger",
  "yieldEventInput.machinery.label": "Maskiner",
  "addYieldEvent.add.success": "Ny udbyttehændelse tilføjet",
  "yield.stock.summary.header": "Udbytter & høster på lager",

  // Fertilizer events
  "inputs.outputs.fertlizer.title": "Gødning",
  "inputs.outputs.combined.title": "Registreringer",
  "records.empty.title": "Ingen registreringer endnu",
  "records.empty.description":
    "Registreringer over dine bedriftsaktiviteter vises her. Begynd med at tilføje marker og registrere hændelser som såning, fodring eller høst.",
  "fertilizerEventInput.title": "Gødning",
  "fertilizerEvent.fertilizerType.label.ORGANIC": "Organisk",
  "fertilizerEvent.fertilizerType.label.SYNTHETIC": "Syntetisk",
  "fertilizerEvent.fertilizerType.label.LIME": "Kalk",
  "fertilizerEvent.fertilizerType.label.BIOSOLIDS": "Biofaststof",
  "fertilizerEvent.fertilizerType.label.BIODIGESTATE": "Biogasafgasset",
  "fertilizerEvent.fertilizerType.label.COMPOST": "Kompost",
  "fertilizerEvent.fertilizerType.label.OTHER": "Andet",
  "fertilizerEvent.organicFertilizerType.label.FYM": "Staldmøg",
  "fertilizerEvent.organicFertilizerType.label.SLURRY": "Gylle",
  "fertilizerEvent.organicFertilizerType.label.DIRTY_WATER": "Snavset vand",
  "fertilizerEventInput.animalType.options.DAIRY_CATTLE": "Malkekvæg",
  "fertilizerEventInput.animalType.options.BEEF_CATTLE": "Kødkvæg",
  "fertilizerEventInput.animalType.options.PIG": "Gris",
  "fertilizerEventInput.animalType.options.SHEEP": "Får",
  "fertilizerEventInput.animalType.options.HORSE": "Hest",
  "fertilizerEventInput.animalType.options.CHICKEN_LITTER": "Hønsemøg",
  "fertilizerEvent.fertilizerProperties.applicationMethod.options.BROADCAST_SPREADER":
    "Bredspreder",
  "fertilizerEvent.fertilizerProperties.applicationMethod.options.MUCK_SPREADER":
    "Møgspreder (bagudkast)",
  "fertilizerEvent.fertilizerProperties.applicationMethod.options.IRRIGATION":
    "Vanding (vandkanon / vandingsmaskine)",
  "fertilizerEvent.fertilizerProperties.applicationMethod.options.DISC_INJECTOR":
    "Skiveinjektor",
  "fertilizerEvent.fertilizerProperties.applicationMethod.options.TRAILING_SHOE":
    "LESS: Slæbesko",
  "fertilizerEvent.fertilizerProperties.applicationMethod.options.DRIBBLE_BAR":
    "LESS: Båndspreder / Slæbeslange",
  "fertilizerEvent.fertilizerProperties.applicationMethod.options.SHALLOW_INJECTION":
    "LESS: Lav nedfældning",
  "fertilizerEvent.fertilizerProperties.applicationMethod.options.DEEP_INJECTION":
    "LESS: Dyb nedfældning",
  "fertilizerEvent.fertilizerProperties.applicationMethod.options.SPLASH_PLATE":
    "Spredeplade",
  "fertilizerEvent.fertilizerProperties.applicationMethod.options.OTHER":
    "Andet",
  "fertilizerProperties.applicationMethod": "Udbringningsmetode",
  "fertilizerEvent.fertilizerProperties.organicType.text":
    "Type af organisk gødning",
  "fertilizerEventInput.animalType.label": "Dyretype",
  "fertilizerEventInput.machinery.label": "Maskiner",
  "fertilizerEvent.fuel.label": "Brændstof (i liter)",
  "fertilizerEventInput.fields.text": "Mark(er)",
  "fertilizerEventDetailView.button.addFertilizerEvent.title":
    "Tilføj gødningshændelse",
  "fertilizerInput.fertilizerType.label": "Type af gødning",
  "organicFertilizer.imported.label": "Importeret?",
  "fertilizerEvent.totalAmount.label": "Udbringningsmængde",
  "fertilizerEvent.totalAmount.rateLabel": "Udbringningsmængde",
  "fertilizerEvent.totalAmount.totalLabel": "Samlet mængde",
  "fertilizerEvent.amountMode.total": "Samlet mængde",
  "fertilizerEvent.amountMode.rate": "Udbringningsmængde",
  "fertilizerEvent.amount.rateHelper": "≈ {rate} {unit} på {area} ha",
  "fertilizerEvent.amount.totalHelper": "≈ {total} {unit} i alt på {area} ha",
  "fertilizerInput.totalAmountUnit.label": "Enhed",
  "fertilizerEvent.totalAmountUnit.option.KG": "kg/ha",
  "fertilizerEvent.totalAmountUnit.option.TONNE": "t/ha",
  "fertilizerEvent.totalAmountUnit.option.M3": "m³/ha",
  "fertilizerEvent.totalAmountUnit.option.GALLONS": "Gallon",
  "fertilizerEvent.totalAmountUnit.totalOption.KG": "kg",
  "fertilizerEvent.totalAmountUnit.totalOption.TONNE": "t",
  "fertilizerEvent.totalAmountUnit.totalOption.M3": "m³",
  "fertilizerEvent.totalAmountUnit.totalOption.GALLONS": "Gallon",
  "fertilizerEvent.field.name": "Mark:",
  "fertilizerEvent.fertilizerEventDate": "{fertilizerEventDate}",
  "fertilizerEvent.typeOfNitrogen.label.UREA": "Urea",
  "fertilizerEvent.typeOfNitrogen.label.PROTECTED_UREA": "Stabiliseret urea",
  "fertilizerEvent.typeOfNitrogen.label.UAN": "UAN",
  "fertilizerEvent.typeOfNitrogen.label.CAN": "Kalkammonsalpeter",
  "fertilizerEvent.typeOfNitrogen.label.CN": "Kalksalpeter",
  "fertilizerEvent.typeOfNitrogen.label.AN": "Ammoniumnitrat",
  "fertilizerEvent.typeOfNitrogen.label.OTHER": "Andet",
  "fertilizerEvent.fertilizerProperties.kPercentage.label": "%K",
  "fertilizerEvent.fertilizerProperties.pPercentage.label": "%P",
  "fertilizerEvent.fertilizerProperties.nPercentage.label": "%N",
  "fertilizerEvent.fertilizerProperties.productName.label": "Produktnavn",
  "fertilizerEvent.fertilizerProperties.typeOfNitrogen.text": "Kvælstoftype",
  "fertilizerEvent.fertilizerProperties.phPriorToApplication.label":
    "pH før udbringning",
  "toolbar.fertilizer-overview.title": "Gødning",
  "updateFertilizerEvent.add.success": "Gødningshændelse opdateret.",
  "addFertilizerEvent.add.success": "Gødningshændelse tilføjet.",

  // Reseed event details
  "reseedEvent.machinery.label": "Maskiner",
  "reseedEvent.reseedType.OVERSEED": "Eftersåning",
  "reseedEvent.reseedType.RESEED": "Nyanlæg",
  "reseedEvent.productName.label": "Frøproduktnavn",
  "reseedEvent.productCost.label": "Omkostning (£, valgfri)",
  "reseedEvent.seedingRate.label": "Udsædsmængde (kg/ha)",
  "reseedEvents.RESEED.explanation":
    "Ved et nyanlæg sås nye frø i bare eller udslidte områder, hvilket ændrer græstypen, f.eks. fra rajgræs til en urteblanding.",
  "reseedEvents.OVERSEED.explanation":
    "Ved eftersåning sås de samme frø på en mark for at reducere bare pletter eller forbedre spiringen af bestemte frø, mens den eksisterende afgrøde bevares.",
  "reseedEvent.totalAmountUnit.label": "Enhedstype",
  "reseedEvent.totalAmountUnit.label.G": "g",
  "reseedEvent.totalAmountUnit.label.KG": "kg",
  "reseedEvent.totalAmountUnit.label.TONNE": "Ton",
  "reseedEvent.totalAmount.label": "Samlet mængde",
  "reseedEvent.amount.heading": "Udbragt mængde",
  "reseedEvent.amountMode.rate": "Udsædsmængde",
  "reseedEvent.amount.rateHelper": "≈ {total} kg på {area} ha",
  "reseedEvent.amount.totalHelper": "≈ {rate} kg/ha på {area} ha",

  // Field preparation
  "toolbar.field-preparation-overview.title": "Markklargøring",
  "fieldPreparationEvent.fields.name": "Marker",
  "fieldPreparationEventDetailView.button.addFieldPreparationEvent.title":
    "Tilføj ny markklargøringshændelse",
  "inputs.outputs.fieldPreparation.title": "Markklargøring",
  "fieldPreparationEvent.fieldPreparationEventDate":
    "{fieldPreparationEventDate}",
  "fieldPreparationEventInput.title": "Markklargøringshændelse",
  "fieldPreparationEventInput.fields.text": "Mark(er)",
  "fieldPreparationEvent.fuel.label": "Brændstof",
  "fieldPreparationEventInput.machinery.label": "Maskiner",
  "updateFieldPreparationEvent.add.success":
    "Markklargøringshændelse opdateret",
  "addFieldPreparationEvent.add.success": "Markklargøringshændelse tilføjet",
  "fieldPreparationEvent.machinery.name": "Maskiner",
  "fieldPreparationEvent.fuel.name": "Brændstof",
  "fieldPreparationEvent.note.name": "Note",

  // Section headings
  "fertilizer.amount.cost.heading": "Mængde & omkostning",
  "fertilizerEvent.productCost.label": "Omkostning (£, valgfri)",
  "fertilizer.operational.cost.heading": "Driftsomkostninger",
  "fertilizerEvent.operationalCost.label": "Omkostninger (i DKK)",
  "reseed.date.type.heading": "Dato & type",
  "reseed.grass.method.heading": "Græstype & såmetode",
  "reseed.product.details.heading": "Produktdetaljer",
  "reseed.amount.cost.heading": "Udsædsmængde & omkostninger",
  "reseed.operational.cost.heading": "Driftsomkostninger",
  "reseed.notes.heading": "Noter",
  "feedPurchase.date.heading": "Dato",
  "feedPurchase.typeUnit.heading": "Fodertype & enhed",
  "feedPurchase.amountCost.heading": "Mængde & omkostninger",
  "feedPurchase.notes.heading": "Noter",
  "fieldPreparation.date.heading": "Dato",
  "fieldPreparation.notes.heading": "Noter",
  "feed.date.heading": "Dato",
  "feed.details.heading": "Foderdetaljer",
  "feed.notes.heading": "Noter",
  "fertilizer.date.type.heading": "Dato & gødningstype",
  "fertilizer.properties.heading": "Gødningsegenskaber",
  "fertilizer.notes.heading": "Noter",
  "yield.date.type.heading": "Dato & udbyttetype",
  "yield.details.heading": "Udbyttedetaljer",
  "yield.notes.heading": "Noter",

  // File management
  "fileEntries.fileUploadType.label.FERTILISER_RECEIPT": "Gødningskvittering",
  "fileEntries.fileUploadType.label.FERTILISER_BAG": "Gødningssæk",
  "fileEntries.fileUploadType.label.SEED_MIXES_RECEIPT":
    "Frøblandingskvittering",
  "fileEntries.fileUploadType.label.SEED_MIXES_BAG": "Frøblandingssæk",
  "fileEntries.fileUploadType.label.FIELD_IMAGES": "Markbilleder",
  "fileEntries.fileUploadType.label.SOIL_TEST_REPORT": "Jordanalyserapport",
  "fileEntries.fileUploadType.label.WATER_TEST_REPORT": "Vandanalyserapport",
  "fileEntries.fileUploadType.label.MILK_RECORDING_REPORT":
    "Ydelseskontrolrapport",
  "fileEntries.fileUploadType.label.CARCASS_REPORT": "Slagteafregning",
  "fileEntries.fileUploadType.label.CARBON_AUDIT_REPORT":
    "CO2-fodaftryksrapport",
  "fileEntries.fileUploadType.label.SOIL_ENVIRONMENT_REPORT":
    "Jord- og miljørapport",
  "fileEntries.fileUploadType.label.DETAILED_NUTRIENT_MANAGEMENT_PLAN":
    "Detaljeret næringsstofplan",
  "fileEntries.fileUploadType.label.BIODIVERSITY_ACTION_PLAN":
    "Biodiversitetshandlingsplan",
  "fileEntries.fileUploadType.label.BIODIVERSITY_HABITAT_MAP":
    "Biodiversitets-habitatkort",
  "fileEntries.fileUploadType.label.SFI_ADVICE_REPORT":
    "SFI-rådgivningsrapport",
  "fileEntries.fileUploadType.label.BIODIVERSITY_SUMMARY_FLOWER":
    "Biodiversitetssammendrag",
  "fileEntries.fileUploadType.label.ACTION_EVIDENCE_PHOTO":
    "Foto som dokumentation",
  "fileEntries.fileUploadType.label.ACTION_EVIDENCE_FILE":
    "Fil som dokumentation",
  "fileEntries.fileUploadType.label.PROGRAMME_CONSENT_FORM":
    "Program-samtykkeerklæring",
  "fileEntries.fileUploadType.label": "Filtype",
  "fileEntries.associatedUserId.label": "Bruger, som filen tilhører",
  "fileEntry.creationDate": "{creationDate}",
  "fileManagementDetailView.button.addFile.title": "Upload ny fil",
  "toolbar.file-management.title": "Filhåndtering",
  "inputs.outputs.fileUpload.title": "Filhåndtering",
  "fileEntry.menu.editView": "Rediger filindgang",
  "fileEntries.fileUploadType.name": "Type",
  "fileEntries.associatedUser.name": "Landmand",
  "fileEntries.createdByUser.name": "Uploadet af",
  "updateFileEntry.add.success": "Filindgang opdateret",
  "fileEntry.add.success": "Filindgang tilføjet",
  "fileEntry.menu.download": "Download",
  "fileEntries.fileName.name": "Filnavn",
  "fileEntryInput.title": "Upload fil",
  "fileEntryInput.button": "Vælg fil",
  "fileEntry.owned.closeable.list": "Mine uploads",
  "fileEntry.not.owned.closeable.list": "Uploadet af en anden til mig",
  "fileEntry.menu.delete": "Slet",
  "fileEntry.delete.success": "Fil slettet",
  "fileEntry.relevant.for.questionnaire.closeable.list": "Relevante filer",
  "confirmdeletedialog.title": "Slet fil",
  "confirmdeletedialog.text":
    "Er du sikker på, at du vil slette filen {fileName}?",
  "who.can.see.my.files": "Hvem kan se mine filer?",
  "confirm.sumbit.file.upload.warning.text":
    "Denne fil bliver også delt med denne bruger: ",
  "cancel.file.upload.submit.label": "Annuller",
  "confirm.file.upload.submit.label": "Upload",
  "upload.file.confirm.title": "Upload fil",
  "confirm.sumbit.file.upload.general.text":
    "Er du sikker på, at du vil uploade denne fil?",
  "who.can.see.my.files.explanation":
    "Kun brugere, der uploader en fil til dig, kan se filen ud over dig. Filer, du uploader til en anden, er kun synlige for dig og personen, du har uploadet filen til.",

  // Arable type
  "arableType.not.set.yet": "Ingen afgrødetype angivet endnu",
  "arableType.details.type.notsetyet": "Ikke angivet endnu",
  "file.uploaded.for": "Uploadet til {receiverName}",

  // Insights navigation
  "go.to.farms.insights": "Bedriftsindsigter",
  "toolbar.farmsinsighs.title": "Bedriftsindsigter",
  "toolbar.projectinsighs.title": "Projektindsigter",
  "projects.dashboard.label": "Projekt-dashboards",
  "corporate.farmers.dashboard.label": "Landmandsdashboards",
  "toolbar.projectinsights.title": "Projektindsigter",

  // Field detail
  "fieldDetail.title": "Marknøgletal",
  "fieldDetail.metrics.title": "Marknøgletal",
  "fieldDetail.availableDryMatter": "Tilgængeligt tørstof",
  "fieldDetail.grazingDaysAhead": "Tilbageværende græsningsdage",
  "fieldDetail.totalCover": "TS-tæthed",
  "fieldDetail.area": "Areal",
  "fieldDetail.grassType": "Græstype",
  "fieldDetail.animals": "Dyr",
  "fieldDetail.coverComputing": "Forbereder dækningsdata",
  "fieldDetail.coverFeedback": "Ser det rigtigt ud?",
  "fieldDetail.coverFeedback.thankYou": "Tak for din feedback!",
  "fieldDetail.coverFeedback.enterCorrectValue": "Indtast korrekt værdi",
  "fieldDetail.setGrassType": "Angiv græstype",
  "fieldDetail.selectGrassType": "Vælg græstype",
  "fieldDetail.setGrassTypeHint": "Hjælper med at forbedre dækningsestimaterne",
  "fieldDetail.setGrassTypeButton": "Angiv",

  // Programmes / dashboards
  "no.accessible.farmer.dashboards.available":
    "Dette dashboard kunne vise landmandsindsigter fra igangværende programmer. Kontakt johannes@ruumi.io for mere information!",
  "no.programmes.available.body":
    "Deltag i et program for at få mest muligt ud af ruumi! \n Vi samarbejder med fødevareforsyningskæden for at hjælpe dig med at forbedre din bedrifts effektivitet og bæredygtighed. Gennem en kort 5-minutters vurdering kan vi se, om du kan have gavn af et program i din forsyningskæde.",
  "no.programmes.available.body.web":
    "Vi samarbejder med fødevareforsyningskæden for at hjælpe dig med at forbedre din bedrifts effektivitet og bæredygtighed. Gennem en kort 5-minutters vurdering kan vi se, om du kan have gavn af et program i din forsyningskæde.",

  // Farm switch
  "farmSwitch.viewDataForDifferentSite": "Vis data for en anden lokation",
  "farmSwitch.current": "(Aktuel)",
  "farmView.loading.title": "Indlæser",
  "farmView.loading.description":
    "Se dyre- og markinformationer fra din lokation!",

  // Feed purchase updates
  "updateFeedPurchase.success": "Foderkøbshændelse opdateret.",
  "createfeedPurchaseEvent.success": "Foderkøbshændelse tilføjet.",

  // No fields modal
  "noFieldsModal.title": "Tilføj marker for at få daglige tørstofestimater",
  "noFieldsModal.description":
    "Se dine marker fra rummet — indtast dit bedriftsnummer for at få satellitindsigter for hver hektar, du driver",
  "noFieldsModal.check.button": "Start import",
  "noFieldsModal.sbi.validation": "Indtast hele bedriftsnummeret på 9 cifre.",
  "noFieldsModal.preview.error":
    "Vi kunne ikke finde brugbare RPA-marker for dette bedriftsnummer. Tjek nummeret, eller tilføj marker manuelt.",
  "noFieldsModal.preview.title": "RPA-marker fundet",
  "noFieldsModal.preview.description":
    "Vælg hvilke RPA-marker der skal importeres, og ret detaljerne, før de oprettes i Ruumi.",
  "noFieldsModal.preview.count": "{count} valgt",
  "noFieldsModal.preview.summary":
    "SBI {sbiNumber} · {selectedCount} af {totalCount} marker valgt",
  "noFieldsModal.preview.sbiNumber": "SBI {sbiNumber}",
  "noFieldsModal.preview.more": "+ {count} marker mere",
  "noFieldsModal.selection.include": "Importer denne mark",
  "noFieldsModal.selection.listTitle": "Marker til import",
  "noFieldsModal.selection.name": "Marknavn",
  "noFieldsModal.selection.selectedField": "Valgt mark",
  "noFieldsModal.selection.selectAll": "Vælg alle",
  "noFieldsModal.selection.deselectAll": "Fravælg alle",
  "noFieldsModal.selection.unnamedField": "Mark uden navn",
  "noFieldsModal.selection.error":
    "Vælg mindst én mark, og udfyld detaljerne for hver valgt mark.",
  "noFieldsModal.fieldType.grass": "Græsmark",
  "noFieldsModal.fieldType.arable": "Agermark",
  "noFieldsModal.progress.checking": "Tjekker bedriftsnummeret hos RPA...",
  "noFieldsModal.progress.importing": "Importerer marker fra RPA",
  "noFieldsModal.progress.importingDescription":
    "Vi viser hver mark, når Ruumi opretter den, eller forklarer hvorfor den ikke kunne importeres.",
  "noFieldsModal.import.button": "Importer marker",
  "noFieldsModal.import.buttonWithCount": "Importer {count} marker",
  "noFieldsModal.import.result.pending": "Venter",
  "noFieldsModal.import.result.imported": "Importeret",
  "noFieldsModal.import.result.notImported": "Ikke importeret",
  "noFieldsModal.import.result.notSelected":
    "Denne mark blev ikke valgt til import.",
  "noFieldsModal.manual.button": "Tilføj marker manuelt",
  "noFieldsModal.manual.inlineTitle": "Tilføj marker på en anden måde",
  "noFieldsModal.manual.title":
    "Tegn dine marker, eller send din fil til Ruumi, så hjælper vi dig",
  "noFieldsModal.manual.draw.title": "Tegn markgrænser",
  "noFieldsModal.manual.draw.description":
    "Brug Ruumi-værktøjet til at tegne dine markgrænser",
  "noFieldsModal.manual.support.title": "Kontakt Ruumi",
  "noFieldsModal.manual.support.description":
    "Send os din fil, så tilføjer vi dine marker for dig",
  "noFieldsModal.draw.title": "Tegn markgrænser",
  "noFieldsModal.support.title": "Kontakt Ruumi",
  "noFieldsModal.back": "Tilbage til import",
  "noFieldsModal.import.error": "Markerne kunne ikke importeres",
  "noFieldsModal.success.title": "Import afsluttet",
  "noFieldsModal.success.summaryAllImported":
    "{importedCount} marker importeret.",
  "noFieldsModal.success.summaryWithFailures":
    "{importedCount} marker importeret. {notImportedCount} marker blev ikke importeret.",
  "noFieldsModal.success.description":
    "{count} marker er blevet oprettet i Ruumi.",
  "noFieldsModal.success.dryMatter":
    "Vi beregner nu tørstof for disse marker. Det kan tage lidt tid, så nogle satellitindsigter kan blive vist gradvist.",
  "noFieldsModal.success.button": "Vis marker",

  // Programmes
  "programmes.toolbar.title": "Programmer",
  "programmes.title": "Programmer",
  "programmes.viewProgramme": "Vis program",
  "programmes.notStarted": "Ikke startet",
  "programmes.inProgress": "I gang",
  "programmes.quickAssessment": "Hurtigvurdering",
  "programmes.planActions": "Planlæg handlinger",
  "programme.in.developement":
    "Programmet med din forsyningskæde er stadig under udvikling. Vi vender tilbage, så snart vi er klar! Brug i mellemtiden ruumi-appen, og tøv ikke med at kontakte os, hvis du har spørgsmål.",
  "action.plan.submitted.thank.you":
    "Nedenfor kan du se de handlinger, du har valgt som en del af programmet. Husk at opbevare dokumentation, og tøv ikke med at kontakte ruumi eller din rådgiver, hvis du har brug for hjælp.",
  "action.plan.submitted.but.not.available.yet":
    "Tak for indsendelse af din handlingsplan! Din programrådgiver vil gennemgå dine valg og vende tilbage til dig med næste skridt snarest. Brug i mellemtiden ruumi-appen, og tøv ikke med at kontakte os, hvis du har spørgsmål.",
  "quick.assessment.thank.you":
    "Tak fordi du tog dig tid til at fortælle os mere om din bedrift!\nHvis vi finder et program, der kan være nyttigt for dig, vender vi tilbage. Brug i mellemtiden ruumi-appen, og tøv ikke med at kontakte os, hvis du har spørgsmål.",
  "quick.assessment.thank.you.web":
    "Hvis vi finder et program, der kan være nyttigt for dig, vender vi tilbage. Brug i mellemtiden ruumi-appen, og tøv ikke med at kontakte os, hvis du har spørgsmål.",
  "farmSwitch.addNewFarm": "Tilføj ny bedrift",

  // Planner
  "planner.title": "Planlægning",
  "planner.programmes.title": "Mine programmer",
  "planner.programmes.noProgrammes":
    "Du er endnu ikke tilmeldt nogen programmer.",
  "planner.programmes.buyerSurvey.title": "Hvem køber dine produkter?",
  "planner.programmes.buyerSurvey.description":
    "Fortæl os, hvem der køber dine produkter, så vi kan finde programmer, der passer til din forsyningskæde.",
  "planner.programmes.buyerSurvey.button":
    "Fortæl os, hvem der køber dine produkter",
  "planner.programmes.buyerSurvey.dialogTitle":
    "Fortæl os, hvem der køber dine produkter",
  "planner.programmes.buyerSurvey.thankYou":
    "Tak fordi du fortalte os, hvem der køber dine produkter. Vi bruger dette til at undersøge passende forsyningskædeprogrammer for din bedrift.",
  "planner.feedPlanning.title": "Foderplanlægning",
  "planner.feedPlanning.noStock":
    "Ingen foderlager registreret. Tilføj foderkøb for at følge dit lager.",
  "planner.viewAll": "Vis alle",
  "planner.calendar.title": "Kalender",
  "planner.actionPlan.title": "Handlingsplan",
  "planner.routines.title": "Rutiner",
  "planner.routines.customRoutines.title": "Andre rutiner",
  "planner.routines.customRoutines.description":
    "Opret og følg dine egne tilbagevendende bedriftsopgaver som at kontrollere vandtrug eller flytte dyr.",
  "planner.comingSoon": "Kommer snart",
  "planner.farmActivities.title": "Bedriftsaktiviteter",
  "planner.farmActivities.tabs.actionPlan": "Handlingsplan",
  "planner.farmActivities.tabs.calendar": "Kalender",
  "planner.farmActivities.tabs.routines": "Rutiner",
  "planner.farmActivities.quickAssessment.title": "Kom i gang",
  "planner.farmActivities.quickAssessment.description":
    "Lav en hurtigvurdering for at finde programmer, der kan forbedre din bedrifts effektivitet og bæredygtighed.",
  "planner.farmActivities.quickAssessment.button": "Fortæl os om din bedrift",
  "planner.farmActivities.noActions.withProgramme":
    "Du har endnu ikke planlagt nogen handlinger. Besøg dit program for at begynde planlægningen.",
  "planner.farmActivities.noActions.assessmentComplete":
    "Tak for udfyldelse af vurderingen! Vi vender tilbage, hvis vi finder et program, der passer til din bedrift.",
  "planner.farmActivities.noActions.startPlanning":
    "Klik på et program nedenfor for at begynde at planlægge dine handlinger.",
  "planner.farmActivities.calendar.title": "Sæsonkalender",
  "planner.farmActivities.calendar.description":
    "Planlæg og visualiser dine bedriftsaktiviteter over året.",
  "planner.farmActivities.routines.title": "Tilbagevendende rutiner",
  "planner.farmActivities.routines.description":
    "Opsæt og følg daglige, ugentlige og månedlige bedriftsrutiner.",
  "go.to.planner": "Planlægning",

  // Insights
  "insights.yieldInsights.title": "Udbytteindsigter",
  "insights.farmPerformance.title": "Bedriftspræstation",
  "insights.assessments.title": "Vurderinger & anbefalinger",
  "insights.assessments.description":
    "Se jord-, biodiversitets- og vandvurderinger med anbefalinger til din bedrift.",
  "insights.noDashboard": "Intet dashboard tilgængeligt for dette program",
  "insights.dashboardLoadError": "Dashboard kunne ikke indlæses",
  "planner.assessmentComplete":
    "Tak for udfyldelse af vurderingen! Vi vender tilbage, hvis vi finder et program, der passer til din bedrift.",
};
